var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFondo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 2128,
    viewBox: "0 0 1280 2128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_384_21)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 2128,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 1276.5,
    r: 462.5,
    fill: "url(#paint0_radial_384_21)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905,
    cy: 2085,
    r: 313,
    fill: "url(#paint1_radial_384_21)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1280,
    cy: 572,
    r: 313,
    fill: "url(#paint2_radial_384_21)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 106,
    r: 313,
    fill: "url(#paint3_radial_384_21)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_384_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.862 1023.21L408.349 1039.68L379.836 1023.21V990.282L408.349 973.822L436.862 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 973.824L379.836 990.283L351.312 973.824V940.893L379.836 924.434L408.35 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.862 924.433L408.349 940.904L379.836 924.433V891.513L408.349 875.043L436.862 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 875.042L379.836 891.513L351.312 875.042V842.112L379.836 825.652L408.35 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.862 825.652L408.349 842.111L379.836 825.652V792.721L408.349 776.262L436.862 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 776.263L379.836 792.723L351.312 776.263V743.333L379.836 726.873L408.35 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.862 726.872L408.349 743.343L379.836 726.872V693.942L408.349 677.482L436.862 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 677.482L379.836 693.942L351.312 677.482V644.552L379.836 628.092L408.35 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.862 628.093L408.349 644.553L379.836 628.093V595.163L408.349 578.703L436.862 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 578.702L379.836 595.161L351.312 578.702V545.771L379.836 529.301L408.35 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.862 529.312L408.349 545.772L379.836 529.312V496.382L408.349 479.922L436.862 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 479.923L379.836 496.383L351.312 479.923V446.993L379.836 430.533L408.35 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.862 430.532L408.349 446.991L379.836 430.532V397.601L408.349 381.131L436.862 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 381.132L379.836 397.603L351.312 381.132V348.213L379.836 331.742L408.35 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.862 331.751L408.349 348.211L379.836 331.751V298.821L408.349 282.361L436.862 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 282.362L379.836 298.821L351.312 282.362V249.431L379.836 232.961L408.35 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.862 232.962L408.349 249.433L379.836 232.962V200.043L408.349 183.572L436.862 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 183.572L379.836 200.042L351.312 183.572V150.641L379.836 134.182L408.35 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.862 134.181L408.349 150.641L379.836 134.181V101.251L408.349 84.791L436.862 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 84.7904L379.836 101.25L351.312 84.7904V51.8602L379.836 35.4004L408.35 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.862 35.4018L408.349 51.8722L379.836 35.4018V2.4715L408.349 -13.9883L436.862 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 -13.9889L379.836 2.47093L351.312 -13.9889V-46.9191L379.836 -63.3789L408.35 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 1023.21L465.387 1039.68L436.863 1023.21V990.282L465.387 973.822L493.9 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 973.824L436.863 990.283L408.35 973.824V940.893L436.863 924.434L465.387 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 924.433L465.387 940.904L436.863 924.433V891.513L465.387 875.043L493.9 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 875.042L436.863 891.513L408.35 875.042V842.112L436.863 825.652L465.387 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 825.652L465.387 842.111L436.863 825.652V792.721L465.387 776.262L493.9 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 776.263L436.863 792.723L408.35 776.263V743.333L436.863 726.873L465.387 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 726.872L465.387 743.343L436.863 726.872V693.942L465.387 677.482L493.9 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 677.482L436.863 693.942L408.35 677.482V644.552L436.863 628.092L465.387 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 628.093L465.387 644.553L436.863 628.093V595.163L465.387 578.703L493.9 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 578.702L436.863 595.161L408.35 578.702V545.771L436.863 529.301L465.387 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 529.312L465.387 545.772L436.863 529.312V496.382L465.387 479.922L493.9 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 479.923L436.863 496.383L408.35 479.923V446.993L436.863 430.533L465.387 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 430.532L465.387 446.991L436.863 430.532V397.601L465.387 381.131L493.9 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 381.132L436.863 397.603L408.35 381.132V348.213L436.863 331.742L465.387 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 331.751L465.387 348.211L436.863 331.751V298.821L465.387 282.361L493.9 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 282.362L436.863 298.821L408.35 282.362V249.431L436.863 232.961L465.387 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 232.962L465.387 249.433L436.863 232.962V200.043L465.387 183.572L493.9 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 183.572L436.863 200.042L408.35 183.572V150.641L436.863 134.182L465.387 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 134.181L465.387 150.641L436.863 134.181V101.251L465.387 84.791L493.9 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 84.7904L436.863 101.25L408.35 84.7904V51.8602L436.863 35.4004L465.387 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 35.4018L465.387 51.8722L436.863 35.4018V2.4715L465.387 -13.9883L493.9 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 -13.9889L436.863 2.47093L408.35 -13.9889V-46.9191L436.863 -63.3789L465.387 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 1023.21L522.414 1039.68L493.9 1023.21V990.282L522.414 973.822L550.937 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 973.824L493.9 990.283L465.387 973.824V940.893L493.9 924.434L522.413 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 924.433L522.414 940.904L493.9 924.433V891.513L522.414 875.043L550.937 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 875.042L493.9 891.513L465.387 875.042V842.112L493.9 825.652L522.413 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 825.652L522.414 842.111L493.9 825.652V792.721L522.414 776.262L550.937 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 776.263L493.9 792.723L465.387 776.263V743.333L493.9 726.873L522.413 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 726.872L522.414 743.343L493.9 726.872V693.942L522.414 677.482L550.937 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 677.482L493.9 693.942L465.387 677.482V644.552L493.9 628.092L522.413 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 628.093L522.414 644.553L493.9 628.093V595.163L522.414 578.703L550.937 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 578.702L493.9 595.161L465.387 578.702V545.771L493.9 529.301L522.413 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 529.312L522.414 545.772L493.9 529.312V496.382L522.414 479.922L550.937 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 479.923L493.9 496.383L465.387 479.923V446.993L493.9 430.533L522.413 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 430.532L522.414 446.991L493.9 430.532V397.601L522.414 381.131L550.937 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 381.132L493.9 397.603L465.387 381.132V348.213L493.9 331.742L522.413 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 331.751L522.414 348.211L493.9 331.751V298.821L522.414 282.361L550.937 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 282.362L493.9 298.821L465.387 282.362V249.431L493.9 232.961L522.413 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 232.962L522.414 249.433L493.9 232.962V200.043L522.414 183.572L550.937 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 183.572L493.9 200.042L465.387 183.572V150.641L493.9 134.182L522.413 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 134.181L522.414 150.641L493.9 134.181V101.251L522.414 84.791L550.937 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 84.7904L493.9 101.25L465.387 84.7904V51.8602L493.9 35.4004L522.413 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 35.4018L522.414 51.8722L493.9 35.4018V2.4715L522.414 -13.9883L550.937 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 -13.9889L493.9 2.47093L465.387 -13.9889V-46.9191L493.9 -63.3789L522.413 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 1023.21L579.449 1039.68L550.936 1023.21V990.282L579.449 973.822L607.962 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 973.824L550.936 990.283L522.412 973.824V940.893L550.936 924.434L579.449 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 924.433L579.449 940.904L550.936 924.433V891.513L579.449 875.043L607.962 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 875.042L550.936 891.513L522.412 875.042V842.112L550.936 825.652L579.449 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 825.652L579.449 842.111L550.936 825.652V792.721L579.449 776.262L607.962 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 776.263L550.936 792.723L522.412 776.263V743.333L550.936 726.873L579.449 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 726.872L579.449 743.343L550.936 726.872V693.942L579.449 677.482L607.962 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 677.482L550.936 693.942L522.412 677.482V644.552L550.936 628.092L579.449 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 628.093L579.449 644.553L550.936 628.093V595.163L579.449 578.703L607.962 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 578.702L550.936 595.161L522.412 578.702V545.771L550.936 529.301L579.449 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 529.312L579.449 545.772L550.936 529.312V496.382L579.449 479.922L607.962 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 479.923L550.936 496.383L522.412 479.923V446.993L550.936 430.533L579.449 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 430.532L579.449 446.991L550.936 430.532V397.601L579.449 381.131L607.962 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 381.132L550.936 397.603L522.412 381.132V348.213L550.936 331.742L579.449 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 331.751L579.449 348.211L550.936 331.751V298.821L579.449 282.361L607.962 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 282.362L550.936 298.821L522.412 282.362V249.431L550.936 232.961L579.449 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 232.962L579.449 249.433L550.936 232.962V200.043L579.449 183.572L607.962 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 183.572L550.936 200.042L522.412 183.572V150.641L550.936 134.182L579.449 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 134.181L579.449 150.641L550.936 134.181V101.251L579.449 84.791L607.962 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 84.7904L550.936 101.25L522.412 84.7904V51.8602L550.936 35.4004L579.449 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 35.4018L579.449 51.8722L550.936 35.4018V2.4715L579.449 -13.9883L607.962 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 -13.9889L550.936 2.47093L522.412 -13.9889V-46.9191L550.936 -63.3789L579.449 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 1023.21L636.487 1039.68L607.963 1023.21V990.282L636.487 973.822L665 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 973.824L607.962 990.283L579.449 973.824V940.893L607.962 924.434L636.486 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 924.433L636.487 940.904L607.963 924.433V891.513L636.487 875.043L665 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 875.042L607.962 891.513L579.449 875.042V842.112L607.962 825.652L636.486 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 825.652L636.487 842.111L607.963 825.652V792.721L636.487 776.262L665 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 776.263L607.962 792.723L579.449 776.263V743.333L607.962 726.873L636.486 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 726.872L636.487 743.343L607.963 726.872V693.942L636.487 677.482L665 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 677.482L607.962 693.942L579.449 677.482V644.552L607.962 628.092L636.486 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 628.093L636.487 644.553L607.963 628.093V595.163L636.487 578.703L665 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 578.702L607.962 595.161L579.449 578.702V545.771L607.962 529.301L636.486 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 529.312L636.487 545.772L607.963 529.312V496.382L636.487 479.922L665 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 479.923L607.962 496.383L579.449 479.923V446.993L607.962 430.533L636.486 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 430.532L636.487 446.991L607.963 430.532V397.601L636.487 381.131L665 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 381.132L607.962 397.603L579.449 381.132V348.213L607.962 331.742L636.486 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 331.751L636.487 348.211L607.963 331.751V298.821L636.487 282.361L665 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 282.362L607.962 298.821L579.449 282.362V249.431L607.962 232.961L636.486 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 232.962L636.487 249.433L607.963 232.962V200.043L636.487 183.572L665 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 183.572L607.962 200.042L579.449 183.572V150.641L607.962 134.182L636.486 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 134.181L636.487 150.641L607.963 134.181V101.251L636.487 84.791L665 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 84.7904L607.962 101.25L579.449 84.7904V51.8602L607.962 35.4004L636.486 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 35.4018L636.487 51.8722L607.963 35.4018V2.4715L636.487 -13.9883L665 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 -13.9889L607.962 2.47093L579.449 -13.9889V-46.9191L607.962 -63.3789L636.486 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 1023.21L693.513 1039.68L665 1023.21V990.282L693.513 973.822L722.026 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 973.824L665 990.283L636.486 973.824V940.893L665 924.434L693.513 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 924.433L693.513 940.904L665 924.433V891.513L693.513 875.043L722.026 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 875.042L665 891.513L636.486 875.042V842.112L665 825.652L693.513 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 825.652L693.513 842.111L665 825.652V792.721L693.513 776.262L722.026 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 776.263L665 792.723L636.486 776.263V743.333L665 726.873L693.513 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 726.872L693.513 743.343L665 726.872V693.942L693.513 677.482L722.026 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 677.482L665 693.942L636.486 677.482V644.552L665 628.092L693.513 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 628.093L693.513 644.553L665 628.093V595.163L693.513 578.703L722.026 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 578.702L665 595.161L636.486 578.702V545.771L665 529.301L693.513 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 529.312L693.513 545.772L665 529.312V496.382L693.513 479.922L722.026 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 479.923L665 496.383L636.486 479.923V446.993L665 430.533L693.513 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 430.532L693.513 446.991L665 430.532V397.601L693.513 381.131L722.026 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 381.132L665 397.603L636.486 381.132V348.213L665 331.742L693.513 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 331.751L693.513 348.211L665 331.751V298.821L693.513 282.361L722.026 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 282.362L665 298.821L636.486 282.362V249.431L665 232.961L693.513 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 232.962L693.513 249.433L665 232.962V200.043L693.513 183.572L722.026 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 183.572L665 200.042L636.486 183.572V150.641L665 134.182L693.513 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 134.181L693.513 150.641L665 134.181V101.251L693.513 84.791L722.026 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 84.7904L665 101.25L636.486 84.7904V51.8602L665 35.4004L693.513 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 35.4018L693.513 51.8722L665 35.4018V2.4715L693.513 -13.9883L722.026 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 -13.9889L665 2.47093L636.486 -13.9889V-46.9191L665 -63.3789L693.513 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 1023.21L750.551 1039.68L722.027 1023.21V990.282L750.551 973.822L779.064 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 973.824L722.027 990.283L693.514 973.824V940.893L722.027 924.434L750.551 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 924.433L750.551 940.904L722.027 924.433V891.513L750.551 875.043L779.064 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 875.042L722.027 891.513L693.514 875.042V842.112L722.027 825.652L750.551 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 825.652L750.551 842.111L722.027 825.652V792.721L750.551 776.262L779.064 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 776.263L722.027 792.723L693.514 776.263V743.333L722.027 726.873L750.551 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 726.872L750.551 743.343L722.027 726.872V693.942L750.551 677.482L779.064 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 677.482L722.027 693.942L693.514 677.482V644.552L722.027 628.092L750.551 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 628.093L750.551 644.553L722.027 628.093V595.163L750.551 578.703L779.064 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 578.702L722.027 595.161L693.514 578.702V545.771L722.027 529.301L750.551 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 529.312L750.551 545.772L722.027 529.312V496.382L750.551 479.922L779.064 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 479.923L722.027 496.383L693.514 479.923V446.993L722.027 430.533L750.551 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 430.532L750.551 446.991L722.027 430.532V397.601L750.551 381.131L779.064 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 381.132L722.027 397.603L693.514 381.132V348.213L722.027 331.742L750.551 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 331.751L750.551 348.211L722.027 331.751V298.821L750.551 282.361L779.064 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 282.362L722.027 298.821L693.514 282.362V249.431L722.027 232.961L750.551 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 232.962L750.551 249.433L722.027 232.962V200.043L750.551 183.572L779.064 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 183.572L722.027 200.042L693.514 183.572V150.641L722.027 134.182L750.551 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 134.181L750.551 150.641L722.027 134.181V101.251L750.551 84.791L779.064 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 84.7904L722.027 101.25L693.514 84.7904V51.8602L722.027 35.4004L750.551 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 35.4018L750.551 51.8722L722.027 35.4018V2.4715L750.551 -13.9883L779.064 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 -13.9889L722.027 2.47093L693.514 -13.9889V-46.9191L722.027 -63.3789L750.551 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 1023.21L807.578 1039.68L779.064 1023.21V990.282L807.578 973.822L836.102 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 973.824L779.064 990.283L750.551 973.824V940.893L779.064 924.434L807.577 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 924.433L807.578 940.904L779.064 924.433V891.513L807.578 875.043L836.102 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 875.042L779.064 891.513L750.551 875.042V842.112L779.064 825.652L807.577 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 825.652L807.578 842.111L779.064 825.652V792.721L807.578 776.262L836.102 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 776.263L779.064 792.723L750.551 776.263V743.333L779.064 726.873L807.577 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 726.872L807.578 743.343L779.064 726.872V693.942L807.578 677.482L836.102 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 677.482L779.064 693.942L750.551 677.482V644.552L779.064 628.092L807.577 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 628.093L807.578 644.553L779.064 628.093V595.163L807.578 578.703L836.102 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 578.702L779.064 595.161L750.551 578.702V545.771L779.064 529.301L807.577 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 529.312L807.578 545.772L779.064 529.312V496.382L807.578 479.922L836.102 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 479.923L779.064 496.383L750.551 479.923V446.993L779.064 430.533L807.577 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 430.532L807.578 446.991L779.064 430.532V397.601L807.578 381.131L836.102 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 381.132L779.064 397.603L750.551 381.132V348.213L779.064 331.742L807.577 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 331.751L807.578 348.211L779.064 331.751V298.821L807.578 282.361L836.102 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 282.362L779.064 298.821L750.551 282.362V249.431L779.064 232.961L807.577 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 232.962L807.578 249.433L779.064 232.962V200.043L807.578 183.572L836.102 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 183.572L779.064 200.042L750.551 183.572V150.641L779.064 134.182L807.577 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 134.181L807.578 150.641L779.064 134.181V101.251L807.578 84.791L836.102 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 84.7904L779.064 101.25L750.551 84.7904V51.8602L779.064 35.4004L807.577 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 35.4018L807.578 51.8722L779.064 35.4018V2.4715L807.578 -13.9883L836.102 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 -13.9889L779.064 2.47093L750.551 -13.9889V-46.9191L779.064 -63.3789L807.577 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 1023.21L864.613 1039.68L836.1 1023.21V990.282L864.613 973.822L893.126 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 973.824L836.1 990.283L807.576 973.824V940.893L836.1 924.434L864.613 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 924.433L864.613 940.904L836.1 924.433V891.513L864.613 875.043L893.126 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 875.042L836.1 891.513L807.576 875.042V842.112L836.1 825.652L864.613 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 825.652L864.613 842.111L836.1 825.652V792.721L864.613 776.262L893.126 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 776.263L836.1 792.723L807.576 776.263V743.333L836.1 726.873L864.613 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 726.872L864.613 743.343L836.1 726.872V693.942L864.613 677.482L893.126 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 677.482L836.1 693.942L807.576 677.482V644.552L836.1 628.092L864.613 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 628.093L864.613 644.553L836.1 628.093V595.163L864.613 578.703L893.126 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 578.702L836.1 595.161L807.576 578.702V545.771L836.1 529.301L864.613 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 529.312L864.613 545.772L836.1 529.312V496.382L864.613 479.922L893.126 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 479.923L836.1 496.383L807.576 479.923V446.993L836.1 430.533L864.613 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 430.532L864.613 446.991L836.1 430.532V397.601L864.613 381.131L893.126 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 381.132L836.1 397.603L807.576 381.132V348.213L836.1 331.742L864.613 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 331.751L864.613 348.211L836.1 331.751V298.821L864.613 282.361L893.126 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 282.362L836.1 298.821L807.576 282.362V249.431L836.1 232.961L864.613 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 232.962L864.613 249.433L836.1 232.962V200.043L864.613 183.572L893.126 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 183.572L836.1 200.042L807.576 183.572V150.641L836.1 134.182L864.613 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 134.181L864.613 150.641L836.1 134.181V101.251L864.613 84.791L893.126 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 84.7904L836.1 101.25L807.576 84.7904V51.8602L836.1 35.4004L864.613 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 35.4018L864.613 51.8722L836.1 35.4018V2.4715L864.613 -13.9883L893.126 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 -13.9889L836.1 2.47093L807.576 -13.9889V-46.9191L836.1 -63.3789L864.613 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 1023.21L921.651 1039.68L893.127 1023.21V990.282L921.651 973.822L950.164 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 973.824L893.126 990.283L864.613 973.824V940.893L893.126 924.434L921.65 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 924.433L921.651 940.904L893.127 924.433V891.513L921.651 875.043L950.164 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 875.042L893.126 891.513L864.613 875.042V842.112L893.126 825.652L921.65 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 825.652L921.651 842.111L893.127 825.652V792.721L921.651 776.262L950.164 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 776.263L893.126 792.723L864.613 776.263V743.333L893.126 726.873L921.65 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 726.872L921.651 743.343L893.127 726.872V693.942L921.651 677.482L950.164 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 677.482L893.126 693.942L864.613 677.482V644.552L893.126 628.092L921.65 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 628.093L921.651 644.553L893.127 628.093V595.163L921.651 578.703L950.164 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 578.702L893.126 595.161L864.613 578.702V545.771L893.126 529.301L921.65 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 529.312L921.651 545.772L893.127 529.312V496.382L921.651 479.922L950.164 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 479.923L893.126 496.383L864.613 479.923V446.993L893.126 430.533L921.65 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 430.532L921.651 446.991L893.127 430.532V397.601L921.651 381.131L950.164 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 381.132L893.126 397.603L864.613 381.132V348.213L893.126 331.742L921.65 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 331.751L921.651 348.211L893.127 331.751V298.821L921.651 282.361L950.164 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 282.362L893.126 298.821L864.613 282.362V249.431L893.126 232.961L921.65 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 232.962L921.651 249.433L893.127 232.962V200.043L921.651 183.572L950.164 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 183.572L893.126 200.042L864.613 183.572V150.641L893.126 134.182L921.65 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 134.181L921.651 150.641L893.127 134.181V101.251L921.651 84.791L950.164 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 84.7904L893.126 101.25L864.613 84.7904V51.8602L893.126 35.4004L921.65 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 35.4018L921.651 51.8722L893.127 35.4018V2.4715L921.651 -13.9883L950.164 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 -13.9889L893.126 2.47093L864.613 -13.9889V-46.9191L893.126 -63.3789L921.65 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 1023.21L978.677 1039.68L950.164 1023.21V990.282L978.677 973.822L1007.2 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 973.824L950.164 990.283L921.65 973.824V940.893L950.164 924.434L978.677 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 924.433L978.677 940.904L950.164 924.433V891.513L978.677 875.043L1007.2 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 875.042L950.164 891.513L921.65 875.042V842.112L950.164 825.652L978.677 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 825.652L978.677 842.111L950.164 825.652V792.721L978.677 776.262L1007.2 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 776.263L950.164 792.723L921.65 776.263V743.333L950.164 726.873L978.677 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 726.872L978.677 743.343L950.164 726.872V693.942L978.677 677.482L1007.2 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 677.482L950.164 693.942L921.65 677.482V644.552L950.164 628.092L978.677 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 628.093L978.677 644.553L950.164 628.093V595.163L978.677 578.703L1007.2 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 578.702L950.164 595.161L921.65 578.702V545.771L950.164 529.301L978.677 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 529.312L978.677 545.772L950.164 529.312V496.382L978.677 479.922L1007.2 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 479.923L950.164 496.383L921.65 479.923V446.993L950.164 430.533L978.677 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 430.532L978.677 446.991L950.164 430.532V397.601L978.677 381.131L1007.2 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 381.132L950.164 397.603L921.65 381.132V348.213L950.164 331.742L978.677 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 331.751L978.677 348.211L950.164 331.751V298.821L978.677 282.361L1007.2 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 282.362L950.164 298.821L921.65 282.362V249.431L950.164 232.961L978.677 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 232.962L978.677 249.433L950.164 232.962V200.043L978.677 183.572L1007.2 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 183.572L950.164 200.042L921.65 183.572V150.641L950.164 134.182L978.677 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 134.181L978.677 150.641L950.164 134.181V101.251L978.677 84.791L1007.2 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 84.7904L950.164 101.25L921.65 84.7904V51.8602L950.164 35.4004L978.677 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 35.4018L978.677 51.8722L950.164 35.4018V2.4715L978.677 -13.9883L1007.2 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 -13.9889L950.164 2.47093L921.65 -13.9889V-46.9191L950.164 -63.3789L978.677 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 1023.21L1035.71 1039.68L1007.2 1023.21V990.282L1035.71 973.822L1064.23 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 973.824L1007.2 990.283L978.678 973.824V940.893L1007.2 924.434L1035.71 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 924.433L1035.71 940.904L1007.2 924.433V891.513L1035.71 875.043L1064.23 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 875.042L1007.2 891.513L978.678 875.042V842.112L1007.2 825.652L1035.71 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 825.652L1035.71 842.111L1007.2 825.652V792.721L1035.71 776.262L1064.23 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 776.263L1007.2 792.723L978.678 776.263V743.333L1007.2 726.873L1035.71 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 726.872L1035.71 743.343L1007.2 726.872V693.942L1035.71 677.482L1064.23 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 677.482L1007.2 693.942L978.678 677.482V644.552L1007.2 628.092L1035.71 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 628.093L1035.71 644.553L1007.2 628.093V595.163L1035.71 578.703L1064.23 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 578.702L1007.2 595.161L978.678 578.702V545.771L1007.2 529.301L1035.71 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 529.312L1035.71 545.772L1007.2 529.312V496.382L1035.71 479.922L1064.23 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 479.923L1007.2 496.383L978.678 479.923V446.993L1007.2 430.533L1035.71 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 430.532L1035.71 446.991L1007.2 430.532V397.601L1035.71 381.131L1064.23 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 381.132L1007.2 397.603L978.678 381.132V348.213L1007.2 331.742L1035.71 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 331.751L1035.71 348.211L1007.2 331.751V298.821L1035.71 282.361L1064.23 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 282.362L1007.2 298.821L978.678 282.362V249.431L1007.2 232.961L1035.71 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 232.962L1035.71 249.433L1007.2 232.962V200.043L1035.71 183.572L1064.23 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 183.572L1007.2 200.042L978.678 183.572V150.641L1007.2 134.182L1035.71 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 134.181L1035.71 150.641L1007.2 134.181V101.251L1035.71 84.791L1064.23 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 84.7904L1007.2 101.25L978.678 84.7904V51.8602L1007.2 35.4004L1035.71 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 35.4018L1035.71 51.8722L1007.2 35.4018V2.4715L1035.71 -13.9883L1064.23 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 -13.9889L1007.2 2.47093L978.678 -13.9889V-46.9191L1007.2 -63.3789L1035.71 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 1023.21L1092.75 1039.68L1064.23 1023.21V990.282L1092.75 973.822L1121.27 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 973.824L1064.23 990.283L1035.71 973.824V940.893L1064.23 924.434L1092.75 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 924.433L1092.75 940.904L1064.23 924.433V891.513L1092.75 875.043L1121.27 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 875.042L1064.23 891.513L1035.71 875.042V842.112L1064.23 825.652L1092.75 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 825.652L1092.75 842.111L1064.23 825.652V792.721L1092.75 776.262L1121.27 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 776.263L1064.23 792.723L1035.71 776.263V743.333L1064.23 726.873L1092.75 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 726.872L1092.75 743.343L1064.23 726.872V693.942L1092.75 677.482L1121.27 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 677.482L1064.23 693.942L1035.71 677.482V644.552L1064.23 628.092L1092.75 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 628.093L1092.75 644.553L1064.23 628.093V595.163L1092.75 578.703L1121.27 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 578.702L1064.23 595.161L1035.71 578.702V545.771L1064.23 529.301L1092.75 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 529.312L1092.75 545.772L1064.23 529.312V496.382L1092.75 479.922L1121.27 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 479.923L1064.23 496.383L1035.71 479.923V446.993L1064.23 430.533L1092.75 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 430.532L1092.75 446.991L1064.23 430.532V397.601L1092.75 381.131L1121.27 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 381.132L1064.23 397.603L1035.71 381.132V348.213L1064.23 331.742L1092.75 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 331.751L1092.75 348.211L1064.23 331.751V298.821L1092.75 282.361L1121.27 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 282.362L1064.23 298.821L1035.71 282.362V249.431L1064.23 232.961L1092.75 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 232.962L1092.75 249.433L1064.23 232.962V200.043L1092.75 183.572L1121.27 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 183.572L1064.23 200.042L1035.71 183.572V150.641L1064.23 134.182L1092.75 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 134.181L1092.75 150.641L1064.23 134.181V101.251L1092.75 84.791L1121.27 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 84.7904L1064.23 101.25L1035.71 84.7904V51.8602L1064.23 35.4004L1092.75 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 35.4018L1092.75 51.8722L1064.23 35.4018V2.4715L1092.75 -13.9883L1121.27 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 -13.9889L1064.23 2.47093L1035.71 -13.9889V-46.9191L1064.23 -63.3789L1092.75 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 1023.21L1149.78 1039.68L1121.27 1023.21V990.282L1149.78 973.822L1178.3 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 973.824L1121.27 990.283L1092.75 973.824V940.893L1121.27 924.434L1149.78 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 924.433L1149.78 940.904L1121.27 924.433V891.513L1149.78 875.043L1178.3 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 875.042L1121.27 891.513L1092.75 875.042V842.112L1121.27 825.652L1149.78 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 825.652L1149.78 842.111L1121.27 825.652V792.721L1149.78 776.262L1178.3 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 776.263L1121.27 792.723L1092.75 776.263V743.333L1121.27 726.873L1149.78 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 726.872L1149.78 743.343L1121.27 726.872V693.942L1149.78 677.482L1178.3 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 677.482L1121.27 693.942L1092.75 677.482V644.552L1121.27 628.092L1149.78 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 628.093L1149.78 644.553L1121.27 628.093V595.163L1149.78 578.703L1178.3 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 578.702L1121.27 595.161L1092.75 578.702V545.771L1121.27 529.301L1149.78 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 529.312L1149.78 545.772L1121.27 529.312V496.382L1149.78 479.922L1178.3 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 479.923L1121.27 496.383L1092.75 479.923V446.993L1121.27 430.533L1149.78 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 430.532L1149.78 446.991L1121.27 430.532V397.601L1149.78 381.131L1178.3 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 381.132L1121.27 397.603L1092.75 381.132V348.213L1121.27 331.742L1149.78 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 331.751L1149.78 348.211L1121.27 331.751V298.821L1149.78 282.361L1178.3 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 282.362L1121.27 298.821L1092.75 282.362V249.431L1121.27 232.961L1149.78 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 232.962L1149.78 249.433L1121.27 232.962V200.043L1149.78 183.572L1178.3 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 183.572L1121.27 200.042L1092.75 183.572V150.641L1121.27 134.182L1149.78 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 134.181L1149.78 150.641L1121.27 134.181V101.251L1149.78 84.791L1178.3 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 84.7904L1121.27 101.25L1092.75 84.7904V51.8602L1121.27 35.4004L1149.78 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 35.4018L1149.78 51.8722L1121.27 35.4018V2.4715L1149.78 -13.9883L1178.3 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 -13.9889L1121.27 2.47093L1092.75 -13.9889V-46.9191L1121.27 -63.3789L1149.78 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 1023.21L1206.81 1039.68L1178.3 1023.21V990.282L1206.81 973.822L1235.33 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 973.824L1178.3 990.283L1149.78 973.824V940.893L1178.3 924.434L1206.81 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 924.433L1206.81 940.904L1178.3 924.433V891.513L1206.81 875.043L1235.33 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 875.042L1178.3 891.513L1149.78 875.042V842.112L1178.3 825.652L1206.81 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 825.652L1206.81 842.111L1178.3 825.652V792.721L1206.81 776.262L1235.33 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 776.263L1178.3 792.723L1149.78 776.263V743.333L1178.3 726.873L1206.81 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 726.872L1206.81 743.343L1178.3 726.872V693.942L1206.81 677.482L1235.33 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 677.482L1178.3 693.942L1149.78 677.482V644.552L1178.3 628.092L1206.81 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 628.093L1206.81 644.553L1178.3 628.093V595.163L1206.81 578.703L1235.33 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 578.702L1178.3 595.161L1149.78 578.702V545.771L1178.3 529.301L1206.81 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 529.312L1206.81 545.772L1178.3 529.312V496.382L1206.81 479.922L1235.33 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 479.923L1178.3 496.383L1149.78 479.923V446.993L1178.3 430.533L1206.81 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 430.532L1206.81 446.991L1178.3 430.532V397.601L1206.81 381.131L1235.33 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 381.132L1178.3 397.603L1149.78 381.132V348.213L1178.3 331.742L1206.81 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 331.751L1206.81 348.211L1178.3 331.751V298.821L1206.81 282.361L1235.33 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 282.362L1178.3 298.821L1149.78 282.362V249.431L1178.3 232.961L1206.81 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 232.962L1206.81 249.433L1178.3 232.962V200.043L1206.81 183.572L1235.33 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 183.572L1178.3 200.042L1149.78 183.572V150.641L1178.3 134.182L1206.81 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 134.181L1206.81 150.641L1178.3 134.181V101.251L1206.81 84.791L1235.33 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 84.7904L1178.3 101.25L1149.78 84.7904V51.8602L1178.3 35.4004L1206.81 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 35.4018L1206.81 51.8722L1178.3 35.4018V2.4715L1206.81 -13.9883L1235.33 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 -13.9889L1178.3 2.47093L1149.78 -13.9889V-46.9191L1178.3 -63.3789L1206.81 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 1023.21L1263.84 1039.68L1235.33 1023.21V990.282L1263.84 973.822L1292.37 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 973.824L1235.33 990.283L1206.81 973.824V940.893L1235.33 924.434L1263.84 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 924.433L1263.84 940.904L1235.33 924.433V891.513L1263.84 875.043L1292.37 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 875.042L1235.33 891.513L1206.81 875.042V842.112L1235.33 825.652L1263.84 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 825.652L1263.84 842.111L1235.33 825.652V792.721L1263.84 776.262L1292.37 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 776.263L1235.33 792.723L1206.81 776.263V743.333L1235.33 726.873L1263.84 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 726.872L1263.84 743.343L1235.33 726.872V693.942L1263.84 677.482L1292.37 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 677.482L1235.33 693.942L1206.81 677.482V644.552L1235.33 628.092L1263.84 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 628.093L1263.84 644.553L1235.33 628.093V595.163L1263.84 578.703L1292.37 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 578.702L1235.33 595.161L1206.81 578.702V545.771L1235.33 529.301L1263.84 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 529.312L1263.84 545.772L1235.33 529.312V496.382L1263.84 479.922L1292.37 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 479.923L1235.33 496.383L1206.81 479.923V446.993L1235.33 430.533L1263.84 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 430.532L1263.84 446.991L1235.33 430.532V397.601L1263.84 381.131L1292.37 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 381.132L1235.33 397.603L1206.81 381.132V348.213L1235.33 331.742L1263.84 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 331.751L1263.84 348.211L1235.33 331.751V298.821L1263.84 282.361L1292.37 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 282.362L1235.33 298.821L1206.81 282.362V249.431L1235.33 232.961L1263.84 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 232.962L1263.84 249.433L1235.33 232.962V200.043L1263.84 183.572L1292.37 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 183.572L1235.33 200.042L1206.81 183.572V150.641L1235.33 134.182L1263.84 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 134.181L1263.84 150.641L1235.33 134.181V101.251L1263.84 84.791L1292.37 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 84.7904L1235.33 101.25L1206.81 84.7904V51.8602L1235.33 35.4004L1263.84 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 35.4018L1263.84 51.8722L1235.33 35.4018V2.4715L1263.84 -13.9883L1292.37 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 -13.9889L1235.33 2.47093L1206.81 -13.9889V-46.9191L1235.33 -63.3789L1263.84 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 973.824L1292.37 990.283L1263.84 973.824V940.893L1292.37 924.434L1320.88 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 875.042L1292.37 891.513L1263.84 875.042V842.112L1292.37 825.652L1320.88 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 776.263L1292.37 792.723L1263.84 776.263V743.333L1292.37 726.873L1320.88 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 677.482L1292.37 693.942L1263.84 677.482V644.552L1292.37 628.092L1320.88 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 578.702L1292.37 595.161L1263.84 578.702V545.771L1292.37 529.301L1320.88 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 479.923L1292.37 496.383L1263.84 479.923V446.993L1292.37 430.533L1320.88 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 381.132L1292.37 397.603L1263.84 381.132V348.213L1292.37 331.742L1320.88 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 282.362L1292.37 298.821L1263.84 282.362V249.431L1292.37 232.961L1320.88 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 183.572L1292.37 200.042L1263.84 183.572V150.641L1292.37 134.182L1320.88 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 84.7904L1292.37 101.25L1263.84 84.7904V51.8602L1292.37 35.4004L1320.88 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 -13.9889L1292.37 2.47093L1263.84 -13.9889V-46.9191L1292.37 -63.3789L1320.88 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 1023.21L9.12349 1039.68L-19.4004 1023.21V990.282L9.12349 973.822L37.6367 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 973.824L-19.4009 990.283L-47.9141 973.824V940.893L-19.4009 924.434L9.123 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 924.433L9.12349 940.904L-19.4004 924.433V891.513L9.12349 875.043L37.6367 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 875.042L-19.4009 891.513L-47.9141 875.042V842.112L-19.4009 825.652L9.123 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 825.652L9.12349 842.111L-19.4004 825.652V792.721L9.12349 776.262L37.6367 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 776.263L-19.4009 792.723L-47.9141 776.263V743.333L-19.4009 726.873L9.123 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 726.872L9.12349 743.343L-19.4004 726.872V693.942L9.12349 677.482L37.6367 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 677.482L-19.4009 693.942L-47.9141 677.482V644.552L-19.4009 628.092L9.123 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 628.093L9.12349 644.553L-19.4004 628.093V595.163L9.12349 578.703L37.6367 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 578.702L-19.4009 595.161L-47.9141 578.702V545.771L-19.4009 529.301L9.123 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 529.312L9.12349 545.772L-19.4004 529.312V496.382L9.12349 479.922L37.6367 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 479.923L-19.4009 496.383L-47.9141 479.923V446.993L-19.4009 430.533L9.123 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 430.532L9.12349 446.991L-19.4004 430.532V397.601L9.12349 381.131L37.6367 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 381.132L-19.4009 397.603L-47.9141 381.132V348.213L-19.4009 331.742L9.123 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 331.751L9.12349 348.211L-19.4004 331.751V298.821L9.12349 282.361L37.6367 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 282.362L-19.4009 298.821L-47.9141 282.362V249.431L-19.4009 232.961L9.123 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 232.962L9.12349 249.433L-19.4004 232.962V200.043L9.12349 183.572L37.6367 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 183.572L-19.4009 200.042L-47.9141 183.572V150.641L-19.4009 134.182L9.123 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 134.181L9.12349 150.641L-19.4004 134.181V101.251L9.12349 84.791L37.6367 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 84.7904L-19.4009 101.25L-47.9141 84.7904V51.8602L-19.4009 35.4004L9.123 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 35.4018L9.12349 51.8722L-19.4004 35.4018V2.4715L9.12349 -13.9883L37.6367 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 -13.9889L-19.4009 2.47093L-47.9141 -13.9889V-46.9191L-19.4009 -63.3789L9.123 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 1023.21L66.1479 1039.68L37.6348 1023.21V990.282L66.1479 973.822L94.6718 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 973.824L37.6343 990.283L9.12109 973.824V940.893L37.6343 924.434L66.1474 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 924.433L66.1479 940.904L37.6348 924.433V891.513L66.1479 875.043L94.6718 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 875.042L37.6343 891.513L9.12109 875.042V842.112L37.6343 825.652L66.1474 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 825.652L66.1479 842.111L37.6348 825.652V792.721L66.1479 776.262L94.6718 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 776.263L37.6343 792.723L9.12109 776.263V743.333L37.6343 726.873L66.1474 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 726.872L66.1479 743.343L37.6348 726.872V693.942L66.1479 677.482L94.6718 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 677.482L37.6343 693.942L9.12109 677.482V644.552L37.6343 628.092L66.1474 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 628.093L66.1479 644.553L37.6348 628.093V595.163L66.1479 578.703L94.6718 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 578.702L37.6343 595.161L9.12109 578.702V545.771L37.6343 529.301L66.1474 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 529.312L66.1479 545.772L37.6348 529.312V496.382L66.1479 479.922L94.6718 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 479.923L37.6343 496.383L9.12109 479.923V446.993L37.6343 430.533L66.1474 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 430.532L66.1479 446.991L37.6348 430.532V397.601L66.1479 381.131L94.6718 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 381.132L37.6343 397.603L9.12109 381.132V348.213L37.6343 331.742L66.1474 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 331.751L66.1479 348.211L37.6348 331.751V298.821L66.1479 282.361L94.6718 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 282.362L37.6343 298.821L9.12109 282.362V249.431L37.6343 232.961L66.1474 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 232.962L66.1479 249.433L37.6348 232.962V200.043L66.1479 183.572L94.6718 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 183.572L37.6343 200.042L9.12109 183.572V150.641L37.6343 134.182L66.1474 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 134.181L66.1479 150.641L37.6348 134.181V101.251L66.1479 84.791L94.6718 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 84.7904L37.6343 101.25L9.12109 84.7904V51.8602L37.6343 35.4004L66.1474 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 35.4018L66.1479 51.8722L37.6348 35.4018V2.4715L66.1479 -13.9883L94.6718 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 -13.9889L37.6343 2.47093L9.12109 -13.9889V-46.9191L37.6343 -63.3789L66.1474 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 1023.21L123.185 1039.68L94.6719 1023.21V990.282L123.185 973.822L151.698 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 973.824L94.6723 990.283L66.1484 973.824V940.893L94.6723 924.434L123.185 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 924.433L123.185 940.904L94.6719 924.433V891.513L123.185 875.043L151.698 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 875.042L94.6723 891.513L66.1484 875.042V842.112L94.6723 825.652L123.185 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 825.652L123.185 842.111L94.6719 825.652V792.721L123.185 776.262L151.698 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 776.263L94.6723 792.723L66.1484 776.263V743.333L94.6723 726.873L123.185 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 726.872L123.185 743.343L94.6719 726.872V693.942L123.185 677.482L151.698 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 677.482L94.6723 693.942L66.1484 677.482V644.552L94.6723 628.092L123.185 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 628.093L123.185 644.553L94.6719 628.093V595.163L123.185 578.703L151.698 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 578.702L94.6723 595.161L66.1484 578.702V545.771L94.6723 529.301L123.185 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 529.312L123.185 545.772L94.6719 529.312V496.382L123.185 479.922L151.698 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 479.923L94.6723 496.383L66.1484 479.923V446.993L94.6723 430.533L123.185 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 430.532L123.185 446.991L94.6719 430.532V397.601L123.185 381.131L151.698 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 381.132L94.6723 397.603L66.1484 381.132V348.213L94.6723 331.742L123.185 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 331.751L123.185 348.211L94.6719 331.751V298.821L123.185 282.361L151.698 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 282.362L94.6723 298.821L66.1484 282.362V249.431L94.6723 232.961L123.185 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 232.962L123.185 249.433L94.6719 232.962V200.043L123.185 183.572L151.698 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 183.572L94.6723 200.042L66.1484 183.572V150.641L94.6723 134.182L123.185 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 134.181L123.185 150.641L94.6719 134.181V101.251L123.185 84.791L151.698 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 84.7904L94.6723 101.25L66.1484 84.7904V51.8602L94.6723 35.4004L123.185 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 35.4018L123.185 51.8722L94.6719 35.4018V2.4715L123.185 -13.9883L151.698 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 -13.9889L94.6723 2.47093L66.1484 -13.9889V-46.9191L94.6723 -63.3789L123.185 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 1023.21L180.212 1039.68L151.699 1023.21V990.282L180.212 973.822L208.736 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 973.824L151.699 990.283L123.186 973.824V940.893L151.699 924.434L180.212 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 924.433L180.212 940.904L151.699 924.433V891.513L180.212 875.043L208.736 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 875.042L151.699 891.513L123.186 875.042V842.112L151.699 825.652L180.212 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 825.652L180.212 842.111L151.699 825.652V792.721L180.212 776.262L208.736 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 776.263L151.699 792.723L123.186 776.263V743.333L151.699 726.873L180.212 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 726.872L180.212 743.343L151.699 726.872V693.942L180.212 677.482L208.736 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 677.482L151.699 693.942L123.186 677.482V644.552L151.699 628.092L180.212 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 628.093L180.212 644.553L151.699 628.093V595.163L180.212 578.703L208.736 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 578.702L151.699 595.161L123.186 578.702V545.771L151.699 529.301L180.212 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 529.312L180.212 545.772L151.699 529.312V496.382L180.212 479.922L208.736 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 479.923L151.699 496.383L123.186 479.923V446.993L151.699 430.533L180.212 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 430.532L180.212 446.991L151.699 430.532V397.601L180.212 381.131L208.736 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 381.132L151.699 397.603L123.186 381.132V348.213L151.699 331.742L180.212 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 331.751L180.212 348.211L151.699 331.751V298.821L180.212 282.361L208.736 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 282.362L151.699 298.821L123.186 282.362V249.431L151.699 232.961L180.212 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 232.962L180.212 249.433L151.699 232.962V200.043L180.212 183.572L208.736 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 183.572L151.699 200.042L123.186 183.572V150.641L151.699 134.182L180.212 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 134.181L180.212 150.641L151.699 134.181V101.251L180.212 84.791L208.736 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 84.7904L151.699 101.25L123.186 84.7904V51.8602L151.699 35.4004L180.212 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 35.4018L180.212 51.8722L151.699 35.4018V2.4715L180.212 -13.9883L208.736 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 -13.9889L151.699 2.47093L123.186 -13.9889V-46.9191L151.699 -63.3789L180.212 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 1023.21L237.248 1039.68L208.734 1023.21V990.282L237.248 973.822L265.761 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 973.824L208.735 990.283L180.211 973.824V940.893L208.735 924.434L237.248 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 924.433L237.248 940.904L208.734 924.433V891.513L237.248 875.043L265.761 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 875.042L208.735 891.513L180.211 875.042V842.112L208.735 825.652L237.248 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 825.652L237.248 842.111L208.734 825.652V792.721L237.248 776.262L265.761 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 776.263L208.735 792.723L180.211 776.263V743.333L208.735 726.873L237.248 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 726.872L237.248 743.343L208.734 726.872V693.942L237.248 677.482L265.761 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 677.482L208.735 693.942L180.211 677.482V644.552L208.735 628.092L237.248 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 628.093L237.248 644.553L208.734 628.093V595.163L237.248 578.703L265.761 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 578.702L208.735 595.161L180.211 578.702V545.771L208.735 529.301L237.248 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 529.312L237.248 545.772L208.734 529.312V496.382L237.248 479.922L265.761 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 479.923L208.735 496.383L180.211 479.923V446.993L208.735 430.533L237.248 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 430.532L237.248 446.991L208.734 430.532V397.601L237.248 381.131L265.761 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 381.132L208.735 397.603L180.211 381.132V348.213L208.735 331.742L237.248 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 331.751L237.248 348.211L208.734 331.751V298.821L237.248 282.361L265.761 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 282.362L208.735 298.821L180.211 282.362V249.431L208.735 232.961L237.248 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 232.962L237.248 249.433L208.734 232.962V200.043L237.248 183.572L265.761 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 183.572L208.735 200.042L180.211 183.572V150.641L208.735 134.182L237.248 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 134.181L237.248 150.641L208.734 134.181V101.251L237.248 84.791L265.761 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 84.7904L208.735 101.25L180.211 84.7904V51.8602L208.735 35.4004L237.248 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 35.4018L237.248 51.8722L208.734 35.4018V2.4715L237.248 -13.9883L265.761 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 -13.9889L208.735 2.47093L180.211 -13.9889V-46.9191L208.735 -63.3789L237.248 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 1023.21L294.286 1039.68L265.762 1023.21V990.282L294.286 973.822L322.799 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 973.824L265.761 990.283L237.248 973.824V940.893L265.761 924.434L294.285 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 924.433L294.286 940.904L265.762 924.433V891.513L294.286 875.043L322.799 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 875.042L265.761 891.513L237.248 875.042V842.112L265.761 825.652L294.285 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 825.652L294.286 842.111L265.762 825.652V792.721L294.286 776.262L322.799 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 776.263L265.761 792.723L237.248 776.263V743.333L265.761 726.873L294.285 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 726.872L294.286 743.343L265.762 726.872V693.942L294.286 677.482L322.799 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 677.482L265.761 693.942L237.248 677.482V644.552L265.761 628.092L294.285 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 628.093L294.286 644.553L265.762 628.093V595.163L294.286 578.703L322.799 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 578.702L265.761 595.161L237.248 578.702V545.771L265.761 529.301L294.285 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 529.312L294.286 545.772L265.762 529.312V496.382L294.286 479.922L322.799 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 479.923L265.761 496.383L237.248 479.923V446.993L265.761 430.533L294.285 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 430.532L294.286 446.991L265.762 430.532V397.601L294.286 381.131L322.799 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 381.132L265.761 397.603L237.248 381.132V348.213L265.761 331.742L294.285 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 331.751L294.286 348.211L265.762 331.751V298.821L294.286 282.361L322.799 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 282.362L265.761 298.821L237.248 282.362V249.431L265.761 232.961L294.285 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 232.962L294.286 249.433L265.762 232.962V200.043L294.286 183.572L322.799 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 183.572L265.761 200.042L237.248 183.572V150.641L265.761 134.182L294.285 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 134.181L294.286 150.641L265.762 134.181V101.251L294.286 84.791L322.799 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 84.7904L265.761 101.25L237.248 84.7904V51.8602L265.761 35.4004L294.285 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 35.4018L294.286 51.8722L265.762 35.4018V2.4715L294.286 -13.9883L322.799 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 -13.9889L265.761 2.47093L237.248 -13.9889V-46.9191L265.761 -63.3789L294.285 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 1023.21L351.312 1039.68L322.799 1023.21V990.282L351.312 973.822L379.836 990.282V1023.21Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 973.824L322.798 990.283L294.285 973.824V940.893L322.798 924.434L351.311 940.893V973.824Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 924.433L351.312 940.904L322.799 924.433V891.513L351.312 875.043L379.836 891.513V924.433Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 875.042L322.798 891.513L294.285 875.042V842.112L322.798 825.652L351.311 842.112V875.042Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 825.652L351.312 842.111L322.799 825.652V792.721L351.312 776.262L379.836 792.721V825.652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 776.263L322.798 792.723L294.285 776.263V743.333L322.798 726.873L351.311 743.333V776.263Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 726.872L351.312 743.343L322.799 726.872V693.942L351.312 677.482L379.836 693.942V726.872Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 677.482L322.798 693.942L294.285 677.482V644.552L322.798 628.092L351.311 644.552V677.482Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 628.093L351.312 644.553L322.799 628.093V595.163L351.312 578.703L379.836 595.163V628.093Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 578.702L322.798 595.161L294.285 578.702V545.771L322.798 529.301L351.311 545.771V578.702Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 529.312L351.312 545.772L322.799 529.312V496.382L351.312 479.922L379.836 496.382V529.312Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 479.923L322.798 496.383L294.285 479.923V446.993L322.798 430.533L351.311 446.993V479.923Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 430.532L351.312 446.991L322.799 430.532V397.601L351.312 381.131L379.836 397.601V430.532Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 381.132L322.798 397.603L294.285 381.132V348.213L322.798 331.742L351.311 348.213V381.132Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 331.751L351.312 348.211L322.799 331.751V298.821L351.312 282.361L379.836 298.821V331.751Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 282.362L322.798 298.821L294.285 282.362V249.431L322.798 232.961L351.311 249.431V282.362Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 232.962L351.312 249.433L322.799 232.962V200.043L351.312 183.572L379.836 200.043V232.962Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 183.572L322.798 200.042L294.285 183.572V150.641L322.798 134.182L351.311 150.641V183.572Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 134.181L351.312 150.641L322.799 134.181V101.251L351.312 84.791L379.836 101.251V134.181Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 84.7904L322.798 101.25L294.285 84.7904V51.8602L322.798 35.4004L351.311 51.8602V84.7904Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 35.4018L351.312 51.8722L322.799 35.4018V2.4715L351.312 -13.9883L379.836 2.4715V35.4018Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 -13.9889L322.798 2.47093L294.285 -13.9889V-46.9191L322.798 -63.3789L351.311 -46.9191V-13.9889Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_384_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.862 2110.91L408.349 2127.38L379.836 2110.91V2077.98L408.349 2061.52L436.862 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 2061.52L379.836 2077.98L351.312 2061.52V2028.59L379.836 2012.13L408.35 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.862 2012.13L408.349 2028.6L379.836 2012.13V1979.21L408.349 1962.74L436.862 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 1962.74L379.836 1979.21L351.312 1962.74V1929.81L379.836 1913.35L408.35 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.862 1913.35L408.349 1929.8L379.836 1913.35V1880.41L408.349 1863.96L436.862 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 1863.96L379.836 1880.42L351.312 1863.96V1831.03L379.836 1814.57L408.35 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.862 1814.57L408.349 1831.04L379.836 1814.57V1781.64L408.349 1765.18L436.862 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 1765.18L379.836 1781.63L351.312 1765.18V1732.24L379.836 1715.79L408.35 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.862 1715.79L408.349 1732.25L379.836 1715.79V1682.86L408.349 1666.4L436.862 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 1666.39L379.836 1682.85L351.312 1666.39V1633.46L379.836 1616.99L408.35 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.862 1617.01L408.349 1633.47L379.836 1617.01V1584.08L408.349 1567.62L436.862 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 1567.62L379.836 1584.08L351.312 1567.62V1534.69L379.836 1518.23L408.35 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.862 1518.22L408.349 1534.68L379.836 1518.22V1485.29L408.349 1468.82L436.862 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 1468.83L379.836 1485.3L351.312 1468.83V1435.91L379.836 1419.44L408.35 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.862 1419.44L408.349 1435.9L379.836 1419.44V1386.51L408.349 1370.05L436.862 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 1370.06L379.836 1386.51L351.312 1370.06V1337.12L379.836 1320.65L408.35 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.862 1320.66L408.349 1337.13L379.836 1320.66V1287.74L408.349 1271.27L436.862 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 1271.27L379.836 1287.74L351.312 1271.27V1238.33L379.836 1221.88L408.35 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.862 1221.87L408.349 1238.33L379.836 1221.87V1188.94L408.349 1172.48L436.862 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 1172.48L379.836 1188.94L351.312 1172.48V1139.55L379.836 1123.09L408.35 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.862 1123.1L408.349 1139.57L379.836 1123.1V1090.16L408.349 1073.71L436.862 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35 1073.7L379.836 1090.16L351.312 1073.7V1040.77L379.836 1024.31L408.35 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 2110.91L465.387 2127.38L436.863 2110.91V2077.98L465.387 2061.52L493.9 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 2061.52L436.863 2077.98L408.35 2061.52V2028.59L436.863 2012.13L465.387 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 2012.13L465.387 2028.6L436.863 2012.13V1979.21L465.387 1962.74L493.9 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 1962.74L436.863 1979.21L408.35 1962.74V1929.81L436.863 1913.35L465.387 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 1913.35L465.387 1929.8L436.863 1913.35V1880.41L465.387 1863.96L493.9 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 1863.96L436.863 1880.42L408.35 1863.96V1831.03L436.863 1814.57L465.387 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 1814.57L465.387 1831.04L436.863 1814.57V1781.64L465.387 1765.18L493.9 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 1765.18L436.863 1781.63L408.35 1765.18V1732.24L436.863 1715.79L465.387 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 1715.79L465.387 1732.25L436.863 1715.79V1682.86L465.387 1666.4L493.9 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 1666.39L436.863 1682.85L408.35 1666.39V1633.46L436.863 1616.99L465.387 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 1617.01L465.387 1633.47L436.863 1617.01V1584.08L465.387 1567.62L493.9 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 1567.62L436.863 1584.08L408.35 1567.62V1534.69L436.863 1518.23L465.387 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 1518.22L465.387 1534.68L436.863 1518.22V1485.29L465.387 1468.82L493.9 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 1468.83L436.863 1485.3L408.35 1468.83V1435.91L436.863 1419.44L465.387 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 1419.44L465.387 1435.9L436.863 1419.44V1386.51L465.387 1370.05L493.9 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 1370.06L436.863 1386.51L408.35 1370.06V1337.12L436.863 1320.65L465.387 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 1320.66L465.387 1337.13L436.863 1320.66V1287.74L465.387 1271.27L493.9 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 1271.27L436.863 1287.74L408.35 1271.27V1238.33L436.863 1221.88L465.387 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 1221.87L465.387 1238.33L436.863 1221.87V1188.94L465.387 1172.48L493.9 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 1172.48L436.863 1188.94L408.35 1172.48V1139.55L436.863 1123.09L465.387 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 1123.1L465.387 1139.57L436.863 1123.1V1090.16L465.387 1073.71L493.9 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.387 1073.7L436.863 1090.16L408.35 1073.7V1040.77L436.863 1024.31L465.387 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 2110.91L522.414 2127.38L493.9 2110.91V2077.98L522.414 2061.52L550.937 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 2061.52L493.9 2077.98L465.387 2061.52V2028.59L493.9 2012.13L522.413 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 2012.13L522.414 2028.6L493.9 2012.13V1979.21L522.414 1962.74L550.937 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 1962.74L493.9 1979.21L465.387 1962.74V1929.81L493.9 1913.35L522.413 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 1913.35L522.414 1929.8L493.9 1913.35V1880.41L522.414 1863.96L550.937 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 1863.96L493.9 1880.42L465.387 1863.96V1831.03L493.9 1814.57L522.413 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 1814.57L522.414 1831.04L493.9 1814.57V1781.64L522.414 1765.18L550.937 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 1765.18L493.9 1781.63L465.387 1765.18V1732.24L493.9 1715.79L522.413 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 1715.79L522.414 1732.25L493.9 1715.79V1682.86L522.414 1666.4L550.937 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 1666.39L493.9 1682.85L465.387 1666.39V1633.46L493.9 1616.99L522.413 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 1617.01L522.414 1633.47L493.9 1617.01V1584.08L522.414 1567.62L550.937 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 1567.62L493.9 1584.08L465.387 1567.62V1534.69L493.9 1518.23L522.413 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 1518.22L522.414 1534.68L493.9 1518.22V1485.29L522.414 1468.82L550.937 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 1468.83L493.9 1485.3L465.387 1468.83V1435.91L493.9 1419.44L522.413 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 1419.44L522.414 1435.9L493.9 1419.44V1386.51L522.414 1370.05L550.937 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 1370.06L493.9 1386.51L465.387 1370.06V1337.12L493.9 1320.65L522.413 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 1320.66L522.414 1337.13L493.9 1320.66V1287.74L522.414 1271.27L550.937 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 1271.27L493.9 1287.74L465.387 1271.27V1238.33L493.9 1221.88L522.413 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 1221.87L522.414 1238.33L493.9 1221.87V1188.94L522.414 1172.48L550.937 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 1172.48L493.9 1188.94L465.387 1172.48V1139.55L493.9 1123.09L522.413 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.937 1123.1L522.414 1139.57L493.9 1123.1V1090.16L522.414 1073.71L550.937 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 1073.7L493.9 1090.16L465.387 1073.7V1040.77L493.9 1024.31L522.413 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 2110.91L579.449 2127.38L550.936 2110.91V2077.98L579.449 2061.52L607.962 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 2061.52L550.936 2077.98L522.412 2061.52V2028.59L550.936 2012.13L579.449 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 2012.13L579.449 2028.6L550.936 2012.13V1979.21L579.449 1962.74L607.962 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 1962.74L550.936 1979.21L522.412 1962.74V1929.81L550.936 1913.35L579.449 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 1913.35L579.449 1929.8L550.936 1913.35V1880.41L579.449 1863.96L607.962 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 1863.96L550.936 1880.42L522.412 1863.96V1831.03L550.936 1814.57L579.449 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 1814.57L579.449 1831.04L550.936 1814.57V1781.64L579.449 1765.18L607.962 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 1765.18L550.936 1781.63L522.412 1765.18V1732.24L550.936 1715.79L579.449 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 1715.79L579.449 1732.25L550.936 1715.79V1682.86L579.449 1666.4L607.962 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 1666.39L550.936 1682.85L522.412 1666.39V1633.46L550.936 1616.99L579.449 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 1617.01L579.449 1633.47L550.936 1617.01V1584.08L579.449 1567.62L607.962 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 1567.62L550.936 1584.08L522.412 1567.62V1534.69L550.936 1518.23L579.449 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 1518.22L579.449 1534.68L550.936 1518.22V1485.29L579.449 1468.82L607.962 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 1468.83L550.936 1485.3L522.412 1468.83V1435.91L550.936 1419.44L579.449 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 1419.44L579.449 1435.9L550.936 1419.44V1386.51L579.449 1370.05L607.962 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 1370.06L550.936 1386.51L522.412 1370.06V1337.12L550.936 1320.65L579.449 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 1320.66L579.449 1337.13L550.936 1320.66V1287.74L579.449 1271.27L607.962 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 1271.27L550.936 1287.74L522.412 1271.27V1238.33L550.936 1221.88L579.449 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 1221.87L579.449 1238.33L550.936 1221.87V1188.94L579.449 1172.48L607.962 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 1172.48L550.936 1188.94L522.412 1172.48V1139.55L550.936 1123.09L579.449 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.962 1123.1L579.449 1139.57L550.936 1123.1V1090.16L579.449 1073.71L607.962 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.449 1073.7L550.936 1090.16L522.412 1073.7V1040.77L550.936 1024.31L579.449 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 2110.91L636.487 2127.38L607.963 2110.91V2077.98L636.487 2061.52L665 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 2061.52L607.962 2077.98L579.449 2061.52V2028.59L607.962 2012.13L636.486 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 2012.13L636.487 2028.6L607.963 2012.13V1979.21L636.487 1962.74L665 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 1962.74L607.962 1979.21L579.449 1962.74V1929.81L607.962 1913.35L636.486 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 1913.35L636.487 1929.8L607.963 1913.35V1880.41L636.487 1863.96L665 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 1863.96L607.962 1880.42L579.449 1863.96V1831.03L607.962 1814.57L636.486 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 1814.57L636.487 1831.04L607.963 1814.57V1781.64L636.487 1765.18L665 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 1765.18L607.962 1781.63L579.449 1765.18V1732.24L607.962 1715.79L636.486 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 1715.79L636.487 1732.25L607.963 1715.79V1682.86L636.487 1666.4L665 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 1666.39L607.962 1682.85L579.449 1666.39V1633.46L607.962 1616.99L636.486 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 1617.01L636.487 1633.47L607.963 1617.01V1584.08L636.487 1567.62L665 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 1567.62L607.962 1584.08L579.449 1567.62V1534.69L607.962 1518.23L636.486 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 1518.22L636.487 1534.68L607.963 1518.22V1485.29L636.487 1468.82L665 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 1468.83L607.962 1485.3L579.449 1468.83V1435.91L607.962 1419.44L636.486 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 1419.44L636.487 1435.9L607.963 1419.44V1386.51L636.487 1370.05L665 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 1370.06L607.962 1386.51L579.449 1370.06V1337.12L607.962 1320.65L636.486 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 1320.66L636.487 1337.13L607.963 1320.66V1287.74L636.487 1271.27L665 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 1271.27L607.962 1287.74L579.449 1271.27V1238.33L607.962 1221.88L636.486 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 1221.87L636.487 1238.33L607.963 1221.87V1188.94L636.487 1172.48L665 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 1172.48L607.962 1188.94L579.449 1172.48V1139.55L607.962 1123.09L636.486 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 1123.1L636.487 1139.57L607.963 1123.1V1090.16L636.487 1073.71L665 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.486 1073.7L607.962 1090.16L579.449 1073.7V1040.77L607.962 1024.31L636.486 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 2110.91L693.513 2127.38L665 2110.91V2077.98L693.513 2061.52L722.026 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 2061.52L665 2077.98L636.486 2061.52V2028.59L665 2012.13L693.513 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 2012.13L693.513 2028.6L665 2012.13V1979.21L693.513 1962.74L722.026 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 1962.74L665 1979.21L636.486 1962.74V1929.81L665 1913.35L693.513 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 1913.35L693.513 1929.8L665 1913.35V1880.41L693.513 1863.96L722.026 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 1863.96L665 1880.42L636.486 1863.96V1831.03L665 1814.57L693.513 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 1814.57L693.513 1831.04L665 1814.57V1781.64L693.513 1765.18L722.026 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 1765.18L665 1781.63L636.486 1765.18V1732.24L665 1715.79L693.513 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 1715.79L693.513 1732.25L665 1715.79V1682.86L693.513 1666.4L722.026 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 1666.39L665 1682.85L636.486 1666.39V1633.46L665 1616.99L693.513 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 1617.01L693.513 1633.47L665 1617.01V1584.08L693.513 1567.62L722.026 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 1567.62L665 1584.08L636.486 1567.62V1534.69L665 1518.23L693.513 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 1518.22L693.513 1534.68L665 1518.22V1485.29L693.513 1468.82L722.026 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 1468.83L665 1485.3L636.486 1468.83V1435.91L665 1419.44L693.513 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 1419.44L693.513 1435.9L665 1419.44V1386.51L693.513 1370.05L722.026 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 1370.06L665 1386.51L636.486 1370.06V1337.12L665 1320.65L693.513 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 1320.66L693.513 1337.13L665 1320.66V1287.74L693.513 1271.27L722.026 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 1271.27L665 1287.74L636.486 1271.27V1238.33L665 1221.88L693.513 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 1221.87L693.513 1238.33L665 1221.87V1188.94L693.513 1172.48L722.026 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 1172.48L665 1188.94L636.486 1172.48V1139.55L665 1123.09L693.513 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.026 1123.1L693.513 1139.57L665 1123.1V1090.16L693.513 1073.71L722.026 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.513 1073.7L665 1090.16L636.486 1073.7V1040.77L665 1024.31L693.513 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 2110.91L750.551 2127.38L722.027 2110.91V2077.98L750.551 2061.52L779.064 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 2061.52L722.027 2077.98L693.514 2061.52V2028.59L722.027 2012.13L750.551 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 2012.13L750.551 2028.6L722.027 2012.13V1979.21L750.551 1962.74L779.064 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 1962.74L722.027 1979.21L693.514 1962.74V1929.81L722.027 1913.35L750.551 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 1913.35L750.551 1929.8L722.027 1913.35V1880.41L750.551 1863.96L779.064 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 1863.96L722.027 1880.42L693.514 1863.96V1831.03L722.027 1814.57L750.551 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 1814.57L750.551 1831.04L722.027 1814.57V1781.64L750.551 1765.18L779.064 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 1765.18L722.027 1781.63L693.514 1765.18V1732.24L722.027 1715.79L750.551 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 1715.79L750.551 1732.25L722.027 1715.79V1682.86L750.551 1666.4L779.064 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 1666.39L722.027 1682.85L693.514 1666.39V1633.46L722.027 1616.99L750.551 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 1617.01L750.551 1633.47L722.027 1617.01V1584.08L750.551 1567.62L779.064 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 1567.62L722.027 1584.08L693.514 1567.62V1534.69L722.027 1518.23L750.551 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 1518.22L750.551 1534.68L722.027 1518.22V1485.29L750.551 1468.82L779.064 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 1468.83L722.027 1485.3L693.514 1468.83V1435.91L722.027 1419.44L750.551 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 1419.44L750.551 1435.9L722.027 1419.44V1386.51L750.551 1370.05L779.064 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 1370.06L722.027 1386.51L693.514 1370.06V1337.12L722.027 1320.65L750.551 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 1320.66L750.551 1337.13L722.027 1320.66V1287.74L750.551 1271.27L779.064 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 1271.27L722.027 1287.74L693.514 1271.27V1238.33L722.027 1221.88L750.551 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 1221.87L750.551 1238.33L722.027 1221.87V1188.94L750.551 1172.48L779.064 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 1172.48L722.027 1188.94L693.514 1172.48V1139.55L722.027 1123.09L750.551 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.064 1123.1L750.551 1139.57L722.027 1123.1V1090.16L750.551 1073.71L779.064 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.551 1073.7L722.027 1090.16L693.514 1073.7V1040.77L722.027 1024.31L750.551 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 2110.91L807.578 2127.38L779.064 2110.91V2077.98L807.578 2061.52L836.102 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 2061.52L779.064 2077.98L750.551 2061.52V2028.59L779.064 2012.13L807.577 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 2012.13L807.578 2028.6L779.064 2012.13V1979.21L807.578 1962.74L836.102 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 1962.74L779.064 1979.21L750.551 1962.74V1929.81L779.064 1913.35L807.577 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 1913.35L807.578 1929.8L779.064 1913.35V1880.41L807.578 1863.96L836.102 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 1863.96L779.064 1880.42L750.551 1863.96V1831.03L779.064 1814.57L807.577 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 1814.57L807.578 1831.04L779.064 1814.57V1781.64L807.578 1765.18L836.102 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 1765.18L779.064 1781.63L750.551 1765.18V1732.24L779.064 1715.79L807.577 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 1715.79L807.578 1732.25L779.064 1715.79V1682.86L807.578 1666.4L836.102 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 1666.39L779.064 1682.85L750.551 1666.39V1633.46L779.064 1616.99L807.577 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 1617.01L807.578 1633.47L779.064 1617.01V1584.08L807.578 1567.62L836.102 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 1567.62L779.064 1584.08L750.551 1567.62V1534.69L779.064 1518.23L807.577 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 1518.22L807.578 1534.68L779.064 1518.22V1485.29L807.578 1468.82L836.102 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 1468.83L779.064 1485.3L750.551 1468.83V1435.91L779.064 1419.44L807.577 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 1419.44L807.578 1435.9L779.064 1419.44V1386.51L807.578 1370.05L836.102 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 1370.06L779.064 1386.51L750.551 1370.06V1337.12L779.064 1320.65L807.577 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 1320.66L807.578 1337.13L779.064 1320.66V1287.74L807.578 1271.27L836.102 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 1271.27L779.064 1287.74L750.551 1271.27V1238.33L779.064 1221.88L807.577 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 1221.87L807.578 1238.33L779.064 1221.87V1188.94L807.578 1172.48L836.102 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 1172.48L779.064 1188.94L750.551 1172.48V1139.55L779.064 1123.09L807.577 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.102 1123.1L807.578 1139.57L779.064 1123.1V1090.16L807.578 1073.71L836.102 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.577 1073.7L779.064 1090.16L750.551 1073.7V1040.77L779.064 1024.31L807.577 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 2110.91L864.613 2127.38L836.1 2110.91V2077.98L864.613 2061.52L893.126 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 2061.52L836.1 2077.98L807.576 2061.52V2028.59L836.1 2012.13L864.613 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 2012.13L864.613 2028.6L836.1 2012.13V1979.21L864.613 1962.74L893.126 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 1962.74L836.1 1979.21L807.576 1962.74V1929.81L836.1 1913.35L864.613 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 1913.35L864.613 1929.8L836.1 1913.35V1880.41L864.613 1863.96L893.126 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 1863.96L836.1 1880.42L807.576 1863.96V1831.03L836.1 1814.57L864.613 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 1814.57L864.613 1831.04L836.1 1814.57V1781.64L864.613 1765.18L893.126 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 1765.18L836.1 1781.63L807.576 1765.18V1732.24L836.1 1715.79L864.613 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 1715.79L864.613 1732.25L836.1 1715.79V1682.86L864.613 1666.4L893.126 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 1666.39L836.1 1682.85L807.576 1666.39V1633.46L836.1 1616.99L864.613 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 1617.01L864.613 1633.47L836.1 1617.01V1584.08L864.613 1567.62L893.126 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 1567.62L836.1 1584.08L807.576 1567.62V1534.69L836.1 1518.23L864.613 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 1518.22L864.613 1534.68L836.1 1518.22V1485.29L864.613 1468.82L893.126 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 1468.83L836.1 1485.3L807.576 1468.83V1435.91L836.1 1419.44L864.613 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 1419.44L864.613 1435.9L836.1 1419.44V1386.51L864.613 1370.05L893.126 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 1370.06L836.1 1386.51L807.576 1370.06V1337.12L836.1 1320.65L864.613 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 1320.66L864.613 1337.13L836.1 1320.66V1287.74L864.613 1271.27L893.126 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 1271.27L836.1 1287.74L807.576 1271.27V1238.33L836.1 1221.88L864.613 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 1221.87L864.613 1238.33L836.1 1221.87V1188.94L864.613 1172.48L893.126 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 1172.48L836.1 1188.94L807.576 1172.48V1139.55L836.1 1123.09L864.613 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.126 1123.1L864.613 1139.57L836.1 1123.1V1090.16L864.613 1073.71L893.126 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.613 1073.7L836.1 1090.16L807.576 1073.7V1040.77L836.1 1024.31L864.613 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 2110.91L921.651 2127.38L893.127 2110.91V2077.98L921.651 2061.52L950.164 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 2061.52L893.126 2077.98L864.613 2061.52V2028.59L893.126 2012.13L921.65 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 2012.13L921.651 2028.6L893.127 2012.13V1979.21L921.651 1962.74L950.164 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 1962.74L893.126 1979.21L864.613 1962.74V1929.81L893.126 1913.35L921.65 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 1913.35L921.651 1929.8L893.127 1913.35V1880.41L921.651 1863.96L950.164 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 1863.96L893.126 1880.42L864.613 1863.96V1831.03L893.126 1814.57L921.65 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 1814.57L921.651 1831.04L893.127 1814.57V1781.64L921.651 1765.18L950.164 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 1765.18L893.126 1781.63L864.613 1765.18V1732.24L893.126 1715.79L921.65 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 1715.79L921.651 1732.25L893.127 1715.79V1682.86L921.651 1666.4L950.164 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 1666.39L893.126 1682.85L864.613 1666.39V1633.46L893.126 1616.99L921.65 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 1617.01L921.651 1633.47L893.127 1617.01V1584.08L921.651 1567.62L950.164 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 1567.62L893.126 1584.08L864.613 1567.62V1534.69L893.126 1518.23L921.65 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 1518.22L921.651 1534.68L893.127 1518.22V1485.29L921.651 1468.82L950.164 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 1468.83L893.126 1485.3L864.613 1468.83V1435.91L893.126 1419.44L921.65 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 1419.44L921.651 1435.9L893.127 1419.44V1386.51L921.651 1370.05L950.164 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 1370.06L893.126 1386.51L864.613 1370.06V1337.12L893.126 1320.65L921.65 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 1320.66L921.651 1337.13L893.127 1320.66V1287.74L921.651 1271.27L950.164 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 1271.27L893.126 1287.74L864.613 1271.27V1238.33L893.126 1221.88L921.65 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 1221.87L921.651 1238.33L893.127 1221.87V1188.94L921.651 1172.48L950.164 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 1172.48L893.126 1188.94L864.613 1172.48V1139.55L893.126 1123.09L921.65 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.164 1123.1L921.651 1139.57L893.127 1123.1V1090.16L921.651 1073.71L950.164 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.65 1073.7L893.126 1090.16L864.613 1073.7V1040.77L893.126 1024.31L921.65 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 2110.91L978.677 2127.38L950.164 2110.91V2077.98L978.677 2061.52L1007.2 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 2061.52L950.164 2077.98L921.65 2061.52V2028.59L950.164 2012.13L978.677 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 2012.13L978.677 2028.6L950.164 2012.13V1979.21L978.677 1962.74L1007.2 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 1962.74L950.164 1979.21L921.65 1962.74V1929.81L950.164 1913.35L978.677 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 1913.35L978.677 1929.8L950.164 1913.35V1880.41L978.677 1863.96L1007.2 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 1863.96L950.164 1880.42L921.65 1863.96V1831.03L950.164 1814.57L978.677 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 1814.57L978.677 1831.04L950.164 1814.57V1781.64L978.677 1765.18L1007.2 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 1765.18L950.164 1781.63L921.65 1765.18V1732.24L950.164 1715.79L978.677 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 1715.79L978.677 1732.25L950.164 1715.79V1682.86L978.677 1666.4L1007.2 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 1666.39L950.164 1682.85L921.65 1666.39V1633.46L950.164 1616.99L978.677 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 1617.01L978.677 1633.47L950.164 1617.01V1584.08L978.677 1567.62L1007.2 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 1567.62L950.164 1584.08L921.65 1567.62V1534.69L950.164 1518.23L978.677 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 1518.22L978.677 1534.68L950.164 1518.22V1485.29L978.677 1468.82L1007.2 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 1468.83L950.164 1485.3L921.65 1468.83V1435.91L950.164 1419.44L978.677 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 1419.44L978.677 1435.9L950.164 1419.44V1386.51L978.677 1370.05L1007.2 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 1370.06L950.164 1386.51L921.65 1370.06V1337.12L950.164 1320.65L978.677 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 1320.66L978.677 1337.13L950.164 1320.66V1287.74L978.677 1271.27L1007.2 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 1271.27L950.164 1287.74L921.65 1271.27V1238.33L950.164 1221.88L978.677 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 1221.87L978.677 1238.33L950.164 1221.87V1188.94L978.677 1172.48L1007.2 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 1172.48L950.164 1188.94L921.65 1172.48V1139.55L950.164 1123.09L978.677 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.2 1123.1L978.677 1139.57L950.164 1123.1V1090.16L978.677 1073.71L1007.2 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.677 1073.7L950.164 1090.16L921.65 1073.7V1040.77L950.164 1024.31L978.677 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 2110.91L1035.71 2127.38L1007.2 2110.91V2077.98L1035.71 2061.52L1064.23 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 2061.52L1007.2 2077.98L978.678 2061.52V2028.59L1007.2 2012.13L1035.71 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 2012.13L1035.71 2028.6L1007.2 2012.13V1979.21L1035.71 1962.74L1064.23 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 1962.74L1007.2 1979.21L978.678 1962.74V1929.81L1007.2 1913.35L1035.71 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 1913.35L1035.71 1929.8L1007.2 1913.35V1880.41L1035.71 1863.96L1064.23 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 1863.96L1007.2 1880.42L978.678 1863.96V1831.03L1007.2 1814.57L1035.71 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 1814.57L1035.71 1831.04L1007.2 1814.57V1781.64L1035.71 1765.18L1064.23 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 1765.18L1007.2 1781.63L978.678 1765.18V1732.24L1007.2 1715.79L1035.71 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 1715.79L1035.71 1732.25L1007.2 1715.79V1682.86L1035.71 1666.4L1064.23 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 1666.39L1007.2 1682.85L978.678 1666.39V1633.46L1007.2 1616.99L1035.71 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 1617.01L1035.71 1633.47L1007.2 1617.01V1584.08L1035.71 1567.62L1064.23 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 1567.62L1007.2 1584.08L978.678 1567.62V1534.69L1007.2 1518.23L1035.71 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 1518.22L1035.71 1534.68L1007.2 1518.22V1485.29L1035.71 1468.82L1064.23 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 1468.83L1007.2 1485.3L978.678 1468.83V1435.91L1007.2 1419.44L1035.71 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 1419.44L1035.71 1435.9L1007.2 1419.44V1386.51L1035.71 1370.05L1064.23 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 1370.06L1007.2 1386.51L978.678 1370.06V1337.12L1007.2 1320.65L1035.71 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 1320.66L1035.71 1337.13L1007.2 1320.66V1287.74L1035.71 1271.27L1064.23 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 1271.27L1007.2 1287.74L978.678 1271.27V1238.33L1007.2 1221.88L1035.71 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 1221.87L1035.71 1238.33L1007.2 1221.87V1188.94L1035.71 1172.48L1064.23 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 1172.48L1007.2 1188.94L978.678 1172.48V1139.55L1007.2 1123.09L1035.71 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.23 1123.1L1035.71 1139.57L1007.2 1123.1V1090.16L1035.71 1073.71L1064.23 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.71 1073.7L1007.2 1090.16L978.678 1073.7V1040.77L1007.2 1024.31L1035.71 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 2110.91L1092.75 2127.38L1064.23 2110.91V2077.98L1092.75 2061.52L1121.27 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 2061.52L1064.23 2077.98L1035.71 2061.52V2028.59L1064.23 2012.13L1092.75 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 2012.13L1092.75 2028.6L1064.23 2012.13V1979.21L1092.75 1962.74L1121.27 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 1962.74L1064.23 1979.21L1035.71 1962.74V1929.81L1064.23 1913.35L1092.75 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 1913.35L1092.75 1929.8L1064.23 1913.35V1880.41L1092.75 1863.96L1121.27 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 1863.96L1064.23 1880.42L1035.71 1863.96V1831.03L1064.23 1814.57L1092.75 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 1814.57L1092.75 1831.04L1064.23 1814.57V1781.64L1092.75 1765.18L1121.27 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 1765.18L1064.23 1781.63L1035.71 1765.18V1732.24L1064.23 1715.79L1092.75 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 1715.79L1092.75 1732.25L1064.23 1715.79V1682.86L1092.75 1666.4L1121.27 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 1666.39L1064.23 1682.85L1035.71 1666.39V1633.46L1064.23 1616.99L1092.75 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 1617.01L1092.75 1633.47L1064.23 1617.01V1584.08L1092.75 1567.62L1121.27 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 1567.62L1064.23 1584.08L1035.71 1567.62V1534.69L1064.23 1518.23L1092.75 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 1518.22L1092.75 1534.68L1064.23 1518.22V1485.29L1092.75 1468.82L1121.27 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 1468.83L1064.23 1485.3L1035.71 1468.83V1435.91L1064.23 1419.44L1092.75 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 1419.44L1092.75 1435.9L1064.23 1419.44V1386.51L1092.75 1370.05L1121.27 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 1370.06L1064.23 1386.51L1035.71 1370.06V1337.12L1064.23 1320.65L1092.75 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 1320.66L1092.75 1337.13L1064.23 1320.66V1287.74L1092.75 1271.27L1121.27 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 1271.27L1064.23 1287.74L1035.71 1271.27V1238.33L1064.23 1221.88L1092.75 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 1221.87L1092.75 1238.33L1064.23 1221.87V1188.94L1092.75 1172.48L1121.27 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 1172.48L1064.23 1188.94L1035.71 1172.48V1139.55L1064.23 1123.09L1092.75 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.27 1123.1L1092.75 1139.57L1064.23 1123.1V1090.16L1092.75 1073.71L1121.27 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.75 1073.7L1064.23 1090.16L1035.71 1073.7V1040.77L1064.23 1024.31L1092.75 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 2110.91L1149.78 2127.38L1121.27 2110.91V2077.98L1149.78 2061.52L1178.3 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 2061.52L1121.27 2077.98L1092.75 2061.52V2028.59L1121.27 2012.13L1149.78 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 2012.13L1149.78 2028.6L1121.27 2012.13V1979.21L1149.78 1962.74L1178.3 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 1962.74L1121.27 1979.21L1092.75 1962.74V1929.81L1121.27 1913.35L1149.78 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 1913.35L1149.78 1929.8L1121.27 1913.35V1880.41L1149.78 1863.96L1178.3 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 1863.96L1121.27 1880.42L1092.75 1863.96V1831.03L1121.27 1814.57L1149.78 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 1814.57L1149.78 1831.04L1121.27 1814.57V1781.64L1149.78 1765.18L1178.3 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 1765.18L1121.27 1781.63L1092.75 1765.18V1732.24L1121.27 1715.79L1149.78 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 1715.79L1149.78 1732.25L1121.27 1715.79V1682.86L1149.78 1666.4L1178.3 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 1666.39L1121.27 1682.85L1092.75 1666.39V1633.46L1121.27 1616.99L1149.78 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 1617.01L1149.78 1633.47L1121.27 1617.01V1584.08L1149.78 1567.62L1178.3 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 1567.62L1121.27 1584.08L1092.75 1567.62V1534.69L1121.27 1518.23L1149.78 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 1518.22L1149.78 1534.68L1121.27 1518.22V1485.29L1149.78 1468.82L1178.3 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 1468.83L1121.27 1485.3L1092.75 1468.83V1435.91L1121.27 1419.44L1149.78 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 1419.44L1149.78 1435.9L1121.27 1419.44V1386.51L1149.78 1370.05L1178.3 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 1370.06L1121.27 1386.51L1092.75 1370.06V1337.12L1121.27 1320.65L1149.78 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 1320.66L1149.78 1337.13L1121.27 1320.66V1287.74L1149.78 1271.27L1178.3 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 1271.27L1121.27 1287.74L1092.75 1271.27V1238.33L1121.27 1221.88L1149.78 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 1221.87L1149.78 1238.33L1121.27 1221.87V1188.94L1149.78 1172.48L1178.3 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 1172.48L1121.27 1188.94L1092.75 1172.48V1139.55L1121.27 1123.09L1149.78 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.3 1123.1L1149.78 1139.57L1121.27 1123.1V1090.16L1149.78 1073.71L1178.3 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 1073.7L1121.27 1090.16L1092.75 1073.7V1040.77L1121.27 1024.31L1149.78 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 2110.91L1206.81 2127.38L1178.3 2110.91V2077.98L1206.81 2061.52L1235.33 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 2061.52L1178.3 2077.98L1149.78 2061.52V2028.59L1178.3 2012.13L1206.81 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 2012.13L1206.81 2028.6L1178.3 2012.13V1979.21L1206.81 1962.74L1235.33 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 1962.74L1178.3 1979.21L1149.78 1962.74V1929.81L1178.3 1913.35L1206.81 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 1913.35L1206.81 1929.8L1178.3 1913.35V1880.41L1206.81 1863.96L1235.33 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 1863.96L1178.3 1880.42L1149.78 1863.96V1831.03L1178.3 1814.57L1206.81 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 1814.57L1206.81 1831.04L1178.3 1814.57V1781.64L1206.81 1765.18L1235.33 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 1765.18L1178.3 1781.63L1149.78 1765.18V1732.24L1178.3 1715.79L1206.81 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 1715.79L1206.81 1732.25L1178.3 1715.79V1682.86L1206.81 1666.4L1235.33 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 1666.39L1178.3 1682.85L1149.78 1666.39V1633.46L1178.3 1616.99L1206.81 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 1617.01L1206.81 1633.47L1178.3 1617.01V1584.08L1206.81 1567.62L1235.33 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 1567.62L1178.3 1584.08L1149.78 1567.62V1534.69L1178.3 1518.23L1206.81 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 1518.22L1206.81 1534.68L1178.3 1518.22V1485.29L1206.81 1468.82L1235.33 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 1468.83L1178.3 1485.3L1149.78 1468.83V1435.91L1178.3 1419.44L1206.81 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 1419.44L1206.81 1435.9L1178.3 1419.44V1386.51L1206.81 1370.05L1235.33 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 1370.06L1178.3 1386.51L1149.78 1370.06V1337.12L1178.3 1320.65L1206.81 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 1320.66L1206.81 1337.13L1178.3 1320.66V1287.74L1206.81 1271.27L1235.33 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 1271.27L1178.3 1287.74L1149.78 1271.27V1238.33L1178.3 1221.88L1206.81 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 1221.87L1206.81 1238.33L1178.3 1221.87V1188.94L1206.81 1172.48L1235.33 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 1172.48L1178.3 1188.94L1149.78 1172.48V1139.55L1178.3 1123.09L1206.81 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.33 1123.1L1206.81 1139.57L1178.3 1123.1V1090.16L1206.81 1073.71L1235.33 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.81 1073.7L1178.3 1090.16L1149.78 1073.7V1040.77L1178.3 1024.31L1206.81 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 2110.91L1263.84 2127.38L1235.33 2110.91V2077.98L1263.84 2061.52L1292.37 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 2061.52L1235.33 2077.98L1206.81 2061.52V2028.59L1235.33 2012.13L1263.84 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 2012.13L1263.84 2028.6L1235.33 2012.13V1979.21L1263.84 1962.74L1292.37 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 1962.74L1235.33 1979.21L1206.81 1962.74V1929.81L1235.33 1913.35L1263.84 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 1913.35L1263.84 1929.8L1235.33 1913.35V1880.41L1263.84 1863.96L1292.37 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 1863.96L1235.33 1880.42L1206.81 1863.96V1831.03L1235.33 1814.57L1263.84 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 1814.57L1263.84 1831.04L1235.33 1814.57V1781.64L1263.84 1765.18L1292.37 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 1765.18L1235.33 1781.63L1206.81 1765.18V1732.24L1235.33 1715.79L1263.84 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 1715.79L1263.84 1732.25L1235.33 1715.79V1682.86L1263.84 1666.4L1292.37 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 1666.39L1235.33 1682.85L1206.81 1666.39V1633.46L1235.33 1616.99L1263.84 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 1617.01L1263.84 1633.47L1235.33 1617.01V1584.08L1263.84 1567.62L1292.37 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 1567.62L1235.33 1584.08L1206.81 1567.62V1534.69L1235.33 1518.23L1263.84 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 1518.22L1263.84 1534.68L1235.33 1518.22V1485.29L1263.84 1468.82L1292.37 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 1468.83L1235.33 1485.3L1206.81 1468.83V1435.91L1235.33 1419.44L1263.84 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 1419.44L1263.84 1435.9L1235.33 1419.44V1386.51L1263.84 1370.05L1292.37 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 1370.06L1235.33 1386.51L1206.81 1370.06V1337.12L1235.33 1320.65L1263.84 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 1320.66L1263.84 1337.13L1235.33 1320.66V1287.74L1263.84 1271.27L1292.37 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 1271.27L1235.33 1287.74L1206.81 1271.27V1238.33L1235.33 1221.88L1263.84 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 1221.87L1263.84 1238.33L1235.33 1221.87V1188.94L1263.84 1172.48L1292.37 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 1172.48L1235.33 1188.94L1206.81 1172.48V1139.55L1235.33 1123.09L1263.84 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.37 1123.1L1263.84 1139.57L1235.33 1123.1V1090.16L1263.84 1073.71L1292.37 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.84 1073.7L1235.33 1090.16L1206.81 1073.7V1040.77L1235.33 1024.31L1263.84 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 2061.52L1292.37 2077.98L1263.84 2061.52V2028.59L1292.37 2012.13L1320.88 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 1962.74L1292.37 1979.21L1263.84 1962.74V1929.81L1292.37 1913.35L1320.88 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 1863.96L1292.37 1880.42L1263.84 1863.96V1831.03L1292.37 1814.57L1320.88 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 1765.18L1292.37 1781.63L1263.84 1765.18V1732.24L1292.37 1715.79L1320.88 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 1666.39L1292.37 1682.85L1263.84 1666.39V1633.46L1292.37 1616.99L1320.88 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 1567.62L1292.37 1584.08L1263.84 1567.62V1534.69L1292.37 1518.23L1320.88 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 1468.83L1292.37 1485.3L1263.84 1468.83V1435.91L1292.37 1419.44L1320.88 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 1370.06L1292.37 1386.51L1263.84 1370.06V1337.12L1292.37 1320.65L1320.88 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 1271.27L1292.37 1287.74L1263.84 1271.27V1238.33L1292.37 1221.88L1320.88 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 1172.48L1292.37 1188.94L1263.84 1172.48V1139.55L1292.37 1123.09L1320.88 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.88 1073.7L1292.37 1090.16L1263.84 1073.7V1040.77L1292.37 1024.31L1320.88 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 2110.91L9.12349 2127.38L-19.4004 2110.91V2077.98L9.12349 2061.52L37.6367 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 2061.52L-19.4009 2077.98L-47.9141 2061.52V2028.59L-19.4009 2012.13L9.123 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 2012.13L9.12349 2028.6L-19.4004 2012.13V1979.21L9.12349 1962.74L37.6367 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 1962.74L-19.4009 1979.21L-47.9141 1962.74V1929.81L-19.4009 1913.35L9.123 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 1913.35L9.12349 1929.8L-19.4004 1913.35V1880.41L9.12349 1863.96L37.6367 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 1863.96L-19.4009 1880.42L-47.9141 1863.96V1831.03L-19.4009 1814.57L9.123 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 1814.57L9.12349 1831.04L-19.4004 1814.57V1781.64L9.12349 1765.18L37.6367 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 1765.18L-19.4009 1781.63L-47.9141 1765.18V1732.24L-19.4009 1715.79L9.123 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 1715.79L9.12349 1732.25L-19.4004 1715.79V1682.86L9.12349 1666.4L37.6367 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 1666.39L-19.4009 1682.85L-47.9141 1666.39V1633.46L-19.4009 1616.99L9.123 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 1617.01L9.12349 1633.47L-19.4004 1617.01V1584.08L9.12349 1567.62L37.6367 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 1567.62L-19.4009 1584.08L-47.9141 1567.62V1534.69L-19.4009 1518.23L9.123 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 1518.22L9.12349 1534.68L-19.4004 1518.22V1485.29L9.12349 1468.82L37.6367 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 1468.83L-19.4009 1485.3L-47.9141 1468.83V1435.91L-19.4009 1419.44L9.123 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 1419.44L9.12349 1435.9L-19.4004 1419.44V1386.51L9.12349 1370.05L37.6367 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 1370.06L-19.4009 1386.51L-47.9141 1370.06V1337.12L-19.4009 1320.65L9.123 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 1320.66L9.12349 1337.13L-19.4004 1320.66V1287.74L9.12349 1271.27L37.6367 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 1271.27L-19.4009 1287.74L-47.9141 1271.27V1238.33L-19.4009 1221.88L9.123 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 1221.87L9.12349 1238.33L-19.4004 1221.87V1188.94L9.12349 1172.48L37.6367 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 1172.48L-19.4009 1188.94L-47.9141 1172.48V1139.55L-19.4009 1123.09L9.123 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 1123.1L9.12349 1139.57L-19.4004 1123.1V1090.16L9.12349 1073.71L37.6367 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.123 1073.7L-19.4009 1090.16L-47.9141 1073.7V1040.77L-19.4009 1024.31L9.123 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 2110.91L66.1479 2127.38L37.6348 2110.91V2077.98L66.1479 2061.52L94.6718 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 2061.52L37.6343 2077.98L9.12109 2061.52V2028.59L37.6343 2012.13L66.1474 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 2012.13L66.1479 2028.6L37.6348 2012.13V1979.21L66.1479 1962.74L94.6718 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 1962.74L37.6343 1979.21L9.12109 1962.74V1929.81L37.6343 1913.35L66.1474 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 1913.35L66.1479 1929.8L37.6348 1913.35V1880.41L66.1479 1863.96L94.6718 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 1863.96L37.6343 1880.42L9.12109 1863.96V1831.03L37.6343 1814.57L66.1474 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 1814.57L66.1479 1831.04L37.6348 1814.57V1781.64L66.1479 1765.18L94.6718 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 1765.18L37.6343 1781.63L9.12109 1765.18V1732.24L37.6343 1715.79L66.1474 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 1715.79L66.1479 1732.25L37.6348 1715.79V1682.86L66.1479 1666.4L94.6718 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 1666.39L37.6343 1682.85L9.12109 1666.39V1633.46L37.6343 1616.99L66.1474 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 1617.01L66.1479 1633.47L37.6348 1617.01V1584.08L66.1479 1567.62L94.6718 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 1567.62L37.6343 1584.08L9.12109 1567.62V1534.69L37.6343 1518.23L66.1474 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 1518.22L66.1479 1534.68L37.6348 1518.22V1485.29L66.1479 1468.82L94.6718 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 1468.83L37.6343 1485.3L9.12109 1468.83V1435.91L37.6343 1419.44L66.1474 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 1419.44L66.1479 1435.9L37.6348 1419.44V1386.51L66.1479 1370.05L94.6718 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 1370.06L37.6343 1386.51L9.12109 1370.06V1337.12L37.6343 1320.65L66.1474 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 1320.66L66.1479 1337.13L37.6348 1320.66V1287.74L66.1479 1271.27L94.6718 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 1271.27L37.6343 1287.74L9.12109 1271.27V1238.33L37.6343 1221.88L66.1474 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 1221.87L66.1479 1238.33L37.6348 1221.87V1188.94L66.1479 1172.48L94.6718 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 1172.48L37.6343 1188.94L9.12109 1172.48V1139.55L37.6343 1123.09L66.1474 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6718 1123.1L66.1479 1139.57L37.6348 1123.1V1090.16L66.1479 1073.71L94.6718 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1474 1073.7L37.6343 1090.16L9.12109 1073.7V1040.77L37.6343 1024.31L66.1474 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 2110.91L123.185 2127.38L94.6719 2110.91V2077.98L123.185 2061.52L151.698 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 2061.52L94.6723 2077.98L66.1484 2061.52V2028.59L94.6723 2012.13L123.185 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 2012.13L123.185 2028.6L94.6719 2012.13V1979.21L123.185 1962.74L151.698 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 1962.74L94.6723 1979.21L66.1484 1962.74V1929.81L94.6723 1913.35L123.185 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 1913.35L123.185 1929.8L94.6719 1913.35V1880.41L123.185 1863.96L151.698 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 1863.96L94.6723 1880.42L66.1484 1863.96V1831.03L94.6723 1814.57L123.185 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 1814.57L123.185 1831.04L94.6719 1814.57V1781.64L123.185 1765.18L151.698 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 1765.18L94.6723 1781.63L66.1484 1765.18V1732.24L94.6723 1715.79L123.185 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 1715.79L123.185 1732.25L94.6719 1715.79V1682.86L123.185 1666.4L151.698 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 1666.39L94.6723 1682.85L66.1484 1666.39V1633.46L94.6723 1616.99L123.185 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 1617.01L123.185 1633.47L94.6719 1617.01V1584.08L123.185 1567.62L151.698 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 1567.62L94.6723 1584.08L66.1484 1567.62V1534.69L94.6723 1518.23L123.185 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 1518.22L123.185 1534.68L94.6719 1518.22V1485.29L123.185 1468.82L151.698 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 1468.83L94.6723 1485.3L66.1484 1468.83V1435.91L94.6723 1419.44L123.185 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 1419.44L123.185 1435.9L94.6719 1419.44V1386.51L123.185 1370.05L151.698 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 1370.06L94.6723 1386.51L66.1484 1370.06V1337.12L94.6723 1320.65L123.185 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 1320.66L123.185 1337.13L94.6719 1320.66V1287.74L123.185 1271.27L151.698 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 1271.27L94.6723 1287.74L66.1484 1271.27V1238.33L94.6723 1221.88L123.185 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 1221.87L123.185 1238.33L94.6719 1221.87V1188.94L123.185 1172.48L151.698 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 1172.48L94.6723 1188.94L66.1484 1172.48V1139.55L94.6723 1123.09L123.185 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.698 1123.1L123.185 1139.57L94.6719 1123.1V1090.16L123.185 1073.71L151.698 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 1073.7L94.6723 1090.16L66.1484 1073.7V1040.77L94.6723 1024.31L123.185 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 2110.91L180.212 2127.38L151.699 2110.91V2077.98L180.212 2061.52L208.736 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 2061.52L151.699 2077.98L123.186 2061.52V2028.59L151.699 2012.13L180.212 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 2012.13L180.212 2028.6L151.699 2012.13V1979.21L180.212 1962.74L208.736 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 1962.74L151.699 1979.21L123.186 1962.74V1929.81L151.699 1913.35L180.212 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 1913.35L180.212 1929.8L151.699 1913.35V1880.41L180.212 1863.96L208.736 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 1863.96L151.699 1880.42L123.186 1863.96V1831.03L151.699 1814.57L180.212 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 1814.57L180.212 1831.04L151.699 1814.57V1781.64L180.212 1765.18L208.736 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 1765.18L151.699 1781.63L123.186 1765.18V1732.24L151.699 1715.79L180.212 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 1715.79L180.212 1732.25L151.699 1715.79V1682.86L180.212 1666.4L208.736 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 1666.39L151.699 1682.85L123.186 1666.39V1633.46L151.699 1616.99L180.212 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 1617.01L180.212 1633.47L151.699 1617.01V1584.08L180.212 1567.62L208.736 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 1567.62L151.699 1584.08L123.186 1567.62V1534.69L151.699 1518.23L180.212 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 1518.22L180.212 1534.68L151.699 1518.22V1485.29L180.212 1468.82L208.736 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 1468.83L151.699 1485.3L123.186 1468.83V1435.91L151.699 1419.44L180.212 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 1419.44L180.212 1435.9L151.699 1419.44V1386.51L180.212 1370.05L208.736 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 1370.06L151.699 1386.51L123.186 1370.06V1337.12L151.699 1320.65L180.212 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 1320.66L180.212 1337.13L151.699 1320.66V1287.74L180.212 1271.27L208.736 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 1271.27L151.699 1287.74L123.186 1271.27V1238.33L151.699 1221.88L180.212 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 1221.87L180.212 1238.33L151.699 1221.87V1188.94L180.212 1172.48L208.736 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 1172.48L151.699 1188.94L123.186 1172.48V1139.55L151.699 1123.09L180.212 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.736 1123.1L180.212 1139.57L151.699 1123.1V1090.16L180.212 1073.71L208.736 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 1073.7L151.699 1090.16L123.186 1073.7V1040.77L151.699 1024.31L180.212 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 2110.91L237.248 2127.38L208.734 2110.91V2077.98L237.248 2061.52L265.761 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 2061.52L208.735 2077.98L180.211 2061.52V2028.59L208.735 2012.13L237.248 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 2012.13L237.248 2028.6L208.734 2012.13V1979.21L237.248 1962.74L265.761 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 1962.74L208.735 1979.21L180.211 1962.74V1929.81L208.735 1913.35L237.248 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 1913.35L237.248 1929.8L208.734 1913.35V1880.41L237.248 1863.96L265.761 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 1863.96L208.735 1880.42L180.211 1863.96V1831.03L208.735 1814.57L237.248 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 1814.57L237.248 1831.04L208.734 1814.57V1781.64L237.248 1765.18L265.761 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 1765.18L208.735 1781.63L180.211 1765.18V1732.24L208.735 1715.79L237.248 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 1715.79L237.248 1732.25L208.734 1715.79V1682.86L237.248 1666.4L265.761 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 1666.39L208.735 1682.85L180.211 1666.39V1633.46L208.735 1616.99L237.248 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 1617.01L237.248 1633.47L208.734 1617.01V1584.08L237.248 1567.62L265.761 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 1567.62L208.735 1584.08L180.211 1567.62V1534.69L208.735 1518.23L237.248 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 1518.22L237.248 1534.68L208.734 1518.22V1485.29L237.248 1468.82L265.761 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 1468.83L208.735 1485.3L180.211 1468.83V1435.91L208.735 1419.44L237.248 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 1419.44L237.248 1435.9L208.734 1419.44V1386.51L237.248 1370.05L265.761 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 1370.06L208.735 1386.51L180.211 1370.06V1337.12L208.735 1320.65L237.248 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 1320.66L237.248 1337.13L208.734 1320.66V1287.74L237.248 1271.27L265.761 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 1271.27L208.735 1287.74L180.211 1271.27V1238.33L208.735 1221.88L237.248 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 1221.87L237.248 1238.33L208.734 1221.87V1188.94L237.248 1172.48L265.761 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 1172.48L208.735 1188.94L180.211 1172.48V1139.55L208.735 1123.09L237.248 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 1123.1L237.248 1139.57L208.734 1123.1V1090.16L237.248 1073.71L265.761 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.248 1073.7L208.735 1090.16L180.211 1073.7V1040.77L208.735 1024.31L237.248 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 2110.91L294.286 2127.38L265.762 2110.91V2077.98L294.286 2061.52L322.799 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 2061.52L265.761 2077.98L237.248 2061.52V2028.59L265.761 2012.13L294.285 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 2012.13L294.286 2028.6L265.762 2012.13V1979.21L294.286 1962.74L322.799 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 1962.74L265.761 1979.21L237.248 1962.74V1929.81L265.761 1913.35L294.285 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 1913.35L294.286 1929.8L265.762 1913.35V1880.41L294.286 1863.96L322.799 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 1863.96L265.761 1880.42L237.248 1863.96V1831.03L265.761 1814.57L294.285 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 1814.57L294.286 1831.04L265.762 1814.57V1781.64L294.286 1765.18L322.799 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 1765.18L265.761 1781.63L237.248 1765.18V1732.24L265.761 1715.79L294.285 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 1715.79L294.286 1732.25L265.762 1715.79V1682.86L294.286 1666.4L322.799 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 1666.39L265.761 1682.85L237.248 1666.39V1633.46L265.761 1616.99L294.285 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 1617.01L294.286 1633.47L265.762 1617.01V1584.08L294.286 1567.62L322.799 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 1567.62L265.761 1584.08L237.248 1567.62V1534.69L265.761 1518.23L294.285 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 1518.22L294.286 1534.68L265.762 1518.22V1485.29L294.286 1468.82L322.799 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 1468.83L265.761 1485.3L237.248 1468.83V1435.91L265.761 1419.44L294.285 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 1419.44L294.286 1435.9L265.762 1419.44V1386.51L294.286 1370.05L322.799 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 1370.06L265.761 1386.51L237.248 1370.06V1337.12L265.761 1320.65L294.285 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 1320.66L294.286 1337.13L265.762 1320.66V1287.74L294.286 1271.27L322.799 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 1271.27L265.761 1287.74L237.248 1271.27V1238.33L265.761 1221.88L294.285 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 1221.87L294.286 1238.33L265.762 1221.87V1188.94L294.286 1172.48L322.799 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 1172.48L265.761 1188.94L237.248 1172.48V1139.55L265.761 1123.09L294.285 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.799 1123.1L294.286 1139.57L265.762 1123.1V1090.16L294.286 1073.71L322.799 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.285 1073.7L265.761 1090.16L237.248 1073.7V1040.77L265.761 1024.31L294.285 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 2110.91L351.312 2127.38L322.799 2110.91V2077.98L351.312 2061.52L379.836 2077.98V2110.91Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 2061.52L322.798 2077.98L294.285 2061.52V2028.59L322.798 2012.13L351.311 2028.59V2061.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 2012.13L351.312 2028.6L322.799 2012.13V1979.21L351.312 1962.74L379.836 1979.21V2012.13Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 1962.74L322.798 1979.21L294.285 1962.74V1929.81L322.798 1913.35L351.311 1929.81V1962.74Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 1913.35L351.312 1929.8L322.799 1913.35V1880.41L351.312 1863.96L379.836 1880.41V1913.35Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 1863.96L322.798 1880.42L294.285 1863.96V1831.03L322.798 1814.57L351.311 1831.03V1863.96Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 1814.57L351.312 1831.04L322.799 1814.57V1781.64L351.312 1765.18L379.836 1781.64V1814.57Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 1765.18L322.798 1781.63L294.285 1765.18V1732.24L322.798 1715.79L351.311 1732.24V1765.18Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 1715.79L351.312 1732.25L322.799 1715.79V1682.86L351.312 1666.4L379.836 1682.86V1715.79Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 1666.39L322.798 1682.85L294.285 1666.39V1633.46L322.798 1616.99L351.311 1633.46V1666.39Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 1617.01L351.312 1633.47L322.799 1617.01V1584.08L351.312 1567.62L379.836 1584.08V1617.01Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 1567.62L322.798 1584.08L294.285 1567.62V1534.69L322.798 1518.23L351.311 1534.69V1567.62Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 1518.22L351.312 1534.68L322.799 1518.22V1485.29L351.312 1468.82L379.836 1485.29V1518.22Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 1468.83L322.798 1485.3L294.285 1468.83V1435.91L322.798 1419.44L351.311 1435.91V1468.83Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 1419.44L351.312 1435.9L322.799 1419.44V1386.51L351.312 1370.05L379.836 1386.51V1419.44Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 1370.06L322.798 1386.51L294.285 1370.06V1337.12L322.798 1320.65L351.311 1337.12V1370.06Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 1320.66L351.312 1337.13L322.799 1320.66V1287.74L351.312 1271.27L379.836 1287.74V1320.66Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 1271.27L322.798 1287.74L294.285 1271.27V1238.33L322.798 1221.88L351.311 1238.33V1271.27Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 1221.87L351.312 1238.33L322.799 1221.87V1188.94L351.312 1172.48L379.836 1188.94V1221.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 1172.48L322.798 1188.94L294.285 1172.48V1139.55L322.798 1123.09L351.311 1139.55V1172.48Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.836 1123.1L351.312 1139.57L322.799 1123.1V1090.16L351.312 1073.71L379.836 1090.16V1123.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.311 1073.7L322.798 1090.16L294.285 1073.7V1040.77L322.798 1024.31L351.311 1040.77V1073.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_384_21",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.5 1276.5) rotate(90) scale(462.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D20B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9049F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_384_21",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(905 2085) rotate(90) scale(313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9049F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_384_21",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1280 572) rotate(90) scale(313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9049F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_384_21",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130 106) rotate(90) scale(313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_384_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 2128,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_384_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1598,
    height: 1104.29,
    fill: "white",
    transform: "translate(-134 -64)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_384_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1598,
    height: 1104.29,
    fill: "white",
    transform: "translate(-134 1023.69)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondo);
export default __webpack_public_path__ + "static/media/fondo.9f34d40387c980393acc1f22c67f667c.svg";
export { ForwardRef as ReactComponent };